function getFocusableElements(container) {
    const elements = Array.from(
        container.querySelectorAll(
            'summary, a[href], area[href], input:not([type=hidden]):not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex]:not([tabindex^="-"]), [contenteditable], [draggable]',
        ),
    ).filter((el) => !el.hasAttribute('disabled') && isVisible(el));

    return elements.filter((element) => {
        // Check if element is visible
        const style = window.getComputedStyle(element);
        if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') {
            return false;
        }

        // Check if element is within an inert container
        let parent = element.parentElement;
        while (parent && parent !== container) {
            if (parent.hasAttribute('inert')) {
                return false;
            }
            parent = parent.parentElement;
        }

        // Check if element itself is inert
        if (element.hasAttribute('inert')) {
            return false;
        }

        return true;
    });
}

function isVisible(element) {
    return (
        !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length) &&
        window.getComputedStyle(element).visibility !== 'hidden' &&
        !element.hasAttribute('hidden') &&
        element.getAttribute('aria-hidden') !== 'true'
    );
}

function getGlobalDomain(url) {
    const endsWithSlash = Shopify.routes.root.endsWith('/');
    const root = endsWithSlash ? Shopify.routes.root.slice(0, -1) : Shopify.routes.root;
    return `${root}${url}`;
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

    if (summary.nextElementSibling) {
        if (summary.nextElementSibling.getAttribute('id')) {
            summary.setAttribute('aria-controls', summary.nextElementSibling.id);
        }
    }

    summary.addEventListener('click', (event) => {
        event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    if (summary.closest('header-drawer, menu-drawer')) return;
    summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

// Handle mega menu ARIA states
document.querySelectorAll('.mega-menu').forEach((megaMenu) => {
    const trigger = megaMenu.querySelector('a[aria-haspopup="true"]');
    const content = megaMenu.querySelector('.mega-menu__content');

    if (trigger && content) {
        // Handle hover events for desktop
        megaMenu.addEventListener('mouseenter', () => {
            trigger.setAttribute('aria-expanded', 'true');
        });

        megaMenu.addEventListener('mouseleave', () => {
            trigger.setAttribute('aria-expanded', 'false');
        });

        // Handle focus events for keyboard navigation
        trigger.addEventListener('focus', () => {
            trigger.setAttribute('aria-expanded', 'true');
        });

        // Close when focus moves outside the mega menu
        megaMenu.addEventListener('focusout', () => {
            setTimeout(() => {
                if (!megaMenu.contains(document.activeElement)) {
                    trigger.setAttribute('aria-expanded', 'false');
                }
            }, 100);
        });

        // Handle escape key
        megaMenu.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
                trigger.setAttribute('aria-expanded', 'false');
                trigger.focus();
            }
        });
    }
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];

    removeTrapFocus();

    trapFocusHandlers.focusin = (event) => {
        if (event.target !== container && event.target !== last && event.target !== first) return;

        document.addEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.focusout = function () {
        document.removeEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.keydown = function (event) {
        if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
        // On the last focusable element and tab forward, focus the first element.
        if (event.target === last && !event.shiftKey) {
            event.preventDefault();
            first.focus();
        }

        //  On the first focusable element and tab backward, focus the last element.
        if ((event.target === container || event.target === first) && event.shiftKey) {
            event.preventDefault();
            last.focus();
        }
    };

    document.addEventListener('focusout', trapFocusHandlers.focusout);
    document.addEventListener('focusin', trapFocusHandlers.focusin);

    elementToFocus.focus();

    if (
        elementToFocus.tagName === 'INPUT' &&
        ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
        elementToFocus.value
    ) {
        elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
    document.querySelector(':focus-visible');
} catch (e) {
    focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
    const navKeys = [
        'ARROWUP',
        'ARROWDOWN',
        'ARROWLEFT',
        'ARROWRIGHT',
        'TAB',
        'ENTER',
        'SPACE',
        'ESCAPE',
        'HOME',
        'END',
        'PAGEUP',
        'PAGEDOWN',
    ];
    let currentFocusedElement = null;
    let mouseClick = null;

    window.addEventListener('keydown', (event) => {
        if (navKeys.includes(event.code.toUpperCase())) {
            mouseClick = false;
        }
    });

    window.addEventListener('mousedown', (event) => {
        mouseClick = true;
    });

    window.addEventListener(
        'focus',
        () => {
            if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

            if (mouseClick) return;

            currentFocusedElement = document.activeElement;
            currentFocusedElement.classList.add('focused');
        },
        true,
    );
}

function pauseAllMedia() {
    document.querySelectorAll('.js-youtube').forEach((video) => {
        video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });
    document.querySelectorAll('.js-vimeo').forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    document.querySelectorAll('video').forEach((video) => video.pause());
}

function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    document.removeEventListener('focusout', trapFocusHandlers.focusout);
    document.removeEventListener('keydown', trapFocusHandlers.keydown);

    if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    const summaryElement = openDetailsElement.querySelector('summary');
    openDetailsElement.removeAttribute('open');
    summaryElement.setAttribute('aria-expanded', false);
    summaryElement.focus();
}

class CartQuantityInput extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input') ? this.querySelector('input') : this.querySelector('select');
        this.manualUpdateButton = this.querySelector('.quantity-input__update');
        this.changeEvent = new Event('change', { bubbles: true });
        if (this.input.tagName === 'SELECT') {
            this.input.addEventListener('change', this.onInputChange.bind(this));
        } else {
            if (!this.manualUpdateButton) return;
            this.manualUpdateButton.addEventListener('click', this.manualUpdate.bind(this));
        }
        this.querySelectorAll('button:not(.quantity-input__update)').forEach((button) =>
            button.addEventListener('click', this.onButtonClick.bind(this)),
        );

        if (this.select) this.renderSelect();
    }

    quantityUpdateUnsubscriber = undefined;

    connectedCallback() {
        this.validateQtyRules();
        this.quantityUpdateUnsubscriber = addAnalyticsEvents(
            USER_INTERACTION_ANALYTICS_EVENTS.quantityUpdate,
            this.validateQtyRules.bind(this),
        );
    }

    disconnectedCallback() {
        if (this.quantityUpdateUnsubscriber) {
            this.quantityUpdateUnsubscriber();
        }
    }

    manualUpdate(event) {
        event.preventDefault();
        this.input.dispatchEvent(new Event('manual-change', { bubbles: true }));
    }

    generateButton() {
        const button = document.createElement('BUTTON');
        button.textContent = window.cartStrings.update;
        button.type = 'button';
        button.classList.add(...['button', 'button--small']);
        button.addEventListener('click', this.manualUpdate.bind(this));
        return button;
    }

    generateInput(select) {
        if (!select) return;
        const attributes = select.attributes;
        const input = document.createElement('INPUT');
        input.setAttribute('type', 'number');
        for (let i = 0; i < attributes.length; i++) {
            const attribute = attributes[i];
            input.setAttribute(attribute.name, attribute.value);
        }
        input.classList.add('quantity-input--manual');
        this.input = input;
        return input;
    }

    onSelectChange(event) {
        const value = event.target.value;
        if (value === '10+') {
            event.target.replaceWith(...[this.generateInput(event.target), this.generateButton()]);
        }
    }

    onInputChange(event) {
        if (event.target.tagName === 'SELECT') {
            this.onSelectChange(event);
        } else {
            this.validateQtyRules();
        }
    }

    onButtonClick(event) {
        event.preventDefault();
        this.dispatchChange(() => {
            event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
        });
    }

    dispatchChange(changeFunction) {
        const previousValue = this.input.value;
        if (changeFunction) changeFunction();

        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }

    validateQtyRules() {
        const buttonMinus = this.querySelector(".quantity__button[name='minus']");
        const buttonPlus = this.querySelector(".quantity__button[name='plus']");
        if (!buttonMinus || !buttonPlus) return;
        const value = parseInt(this.input.value);
        if (this.input.min) {
            const min = parseInt(this.input.min);
            buttonMinus.classList.toggle('disabled', value <= min);
        }
        if (this.input.max) {
            const max = parseInt(this.input.max);
            buttonPlus.classList.toggle('disabled', value >= max);
        }
    }
}

customElements.define('cart-quantity-input', CartQuantityInput);

class QuantityInput extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input') ? this.querySelector('input') : this.querySelector('select');
        this.changeEvent = new Event('change', { bubbles: true });
        this.input.addEventListener('change', this.onInputChange.bind(this));
        this.querySelectorAll('button').forEach((button) =>
            button.addEventListener('click', this.onButtonClick.bind(this)),
        );
        // Delegated: inner markup is replaced on variant change (see renderProductInfo), but this wrapper stays.
        this.multiBuyButtons = this.closest('product-info')?.querySelector('.multi-buy-buttons');
        if (this.multiBuyButtons) {
            this.multiBuyButtons.addEventListener('click', this.onMultiBuyButtonClick.bind(this));
        }

        if (this.select) this.renderSelect();
    }

    quantityUpdateUnsubscriber = undefined;

    connectedCallback() {
        this.validateQtyRules();
        this.quantityUpdateUnsubscriber = addAnalyticsEvents(
            USER_INTERACTION_ANALYTICS_EVENTS.quantityUpdate,
            this.validateQtyRules.bind(this),
        );
    }

    disconnectedCallback() {
        if (this.quantityUpdateUnsubscriber) {
            this.quantityUpdateUnsubscriber();
        }
    }

    onMultiBuyButtonClick(event) {
        const button = event.target.closest('a.button, .button');
        if (!button || !this.multiBuyButtons.contains(button)) return;
        event.preventDefault();
        const quantity = button.dataset.quantity;
        if (quantity) {
            this.input.value = quantity;
        }
        const selectedButton = this.multiBuyButtons.querySelector('.button.selected');
        if (selectedButton) {
            selectedButton.classList.remove('selected');
        }
        button.classList.add('selected');
    }

    generateInput(select) {
        if (!select) return;
        const attributes = select.attributes;
        const input = document.createElement('INPUT');
        input.setAttribute('type', 'number');
        for (let i = 0; i < attributes.length; i++) {
            const attribute = attributes[i];
            input.setAttribute(attribute.name, attribute.value);
        }
        return input;
    }

    onSelectChange(event) {
        const value = event.target.value;
        if (value === '10+') {
            event.target.replaceWith(this.generateInput(event.target));
        }
    }

    onInputChange(event) {
        if (event.target.tagName === 'SELECT') {
            this.onSelectChange(event);
        } else {
            this.validateQtyRules();
        }
    }

    onButtonClick(event) {
        event.preventDefault();
        this.dispatchChange(() => {
            event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
        });
    }

    dispatchChange(changeFunction) {
        const previousValue = this.input.value;
        if (changeFunction) changeFunction();

        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }

    validateQtyRules() {
        const buttonMinus = this.querySelector(".quantity__button[name='minus']");
        const buttonPlus = this.querySelector(".quantity__button[name='plus']");
        if (!buttonMinus || !buttonPlus) return;
        const value = parseInt(this.input.value);
        if (this.input.min) {
            const min = parseInt(this.input.min);
            buttonMinus.classList.toggle('disabled', value <= min);
        }
        if (this.input.max) {
            const max = parseInt(this.input.max);
            buttonPlus.classList.toggle('disabled', value >= max);
        }
    }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}

function throttle(fn, delay) {
    let lastCall = 0;
    return function (...args) {
        const now = new Date().getTime();
        if (now - lastCall < delay) {
            return;
        }
        lastCall = now;
        return fn(...args);
    };
}

function fetchConfig(type = 'json') {
    return {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
    };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
    window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
    return function () {
        return fn.apply(scope, arguments);
    };
};

Shopify.setSelectorByValue = function (selector, value) {
    for (var i = 0, count = selector.options.length; i < count; i++) {
        var option = selector.options[i];
        if (value == option.value || value == option.innerHTML) {
            selector.selectedIndex = i;
            return i;
        }
    }
};

Shopify.addListener = function (target, eventName, callback) {
    target.addEventListener
        ? target.addEventListener(eventName, callback, false)
        : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
    options = options || {};
    var method = options['method'] || 'post';
    var params = options['parameters'] || {};

    var form = document.createElement('form');
    form.setAttribute('method', method);
    form.setAttribute('action', path);

    for (var key in params) {
        var hiddenField = document.createElement('input');
        hiddenField.setAttribute('type', 'hidden');
        hiddenField.setAttribute('name', key);
        hiddenField.setAttribute('value', params[key]);
        form.appendChild(hiddenField);
    }
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
};

class MenuDrawer extends HTMLElement {
    constructor() {
        super();

        this.mainDetailsToggle = this.querySelector('details');

        this.addEventListener('keyup', this.onKeyUp.bind(this));
        this.addEventListener('focusout', this.onFocusOut.bind(this));
        this.bindEvents();
    }

    bindEvents() {
        this.querySelectorAll('summary').forEach((summary) =>
            summary.addEventListener('click', this.onSummaryClick.bind(this)),
        );
        this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
            button.addEventListener('click', this.onCloseButtonClick.bind(this)),
        );
    }

    onKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        const openDetailsElement = event.target.closest('details[open]');
        if (!openDetailsElement) return;

        openDetailsElement === this.mainDetailsToggle
            ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
            : this.closeSubmenu(openDetailsElement);
    }

    onSummaryClick(event) {
        const summaryElement = event.currentTarget;
        const detailsElement = summaryElement.parentNode;
        const parentMenuElement = detailsElement.closest('.has-submenu');
        const isOpen = detailsElement.hasAttribute('open');
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        function addTrapFocus() {
            trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
            summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
        }

        if (detailsElement === this.mainDetailsToggle) {
            if (isOpen) event.preventDefault();
            isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

            if (window.matchMedia('(max-width: 990px)')) {
                document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
            }
        } else {
            setTimeout(() => {
                detailsElement.classList.add('menu-opening');
                summaryElement.setAttribute('aria-expanded', true);
                parentMenuElement && parentMenuElement.classList.add('submenu-open');
                !reducedMotion || reducedMotion.matches
                    ? addTrapFocus()
                    : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
            }, 100);
        }
    }

    openMenuDrawer(summaryElement) {
        setTimeout(() => {
            this.mainDetailsToggle.classList.add('menu-opening');
        });
        summaryElement.setAttribute('aria-expanded', true);
        trapFocus(this.mainDetailsToggle, summaryElement);
        document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }

    closeMenuDrawer(event, elementToFocus = false) {
        if (event === undefined) return;

        this.mainDetailsToggle.classList.remove('menu-opening');
        this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
            details.classList.remove('menu-opening');
        });
        this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
            submenu.classList.remove('submenu-open');
        });
        document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
        removeTrapFocus(elementToFocus);
        this.closeAnimation(this.mainDetailsToggle, false);

        if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
    }

    onFocusOut() {
        setTimeout(() => {
            if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
                this.closeMenuDrawer();
        });
    }

    onCloseButtonClick(event) {
        const detailsElement = event.currentTarget.closest('details');
        this.closeSubmenu(detailsElement);
    }

    closeSubmenu(detailsElement) {
        const parentMenuElement = detailsElement.closest('.submenu-open');
        parentMenuElement && parentMenuElement.classList.remove('submenu-open');
        detailsElement.classList.remove('menu-opening');
        detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
        removeTrapFocus(detailsElement.querySelector('summary'));
        this.closeAnimation(detailsElement);
    }

    closeAnimation(detailsElement) {
        let animationStart;

        const handleAnimation = (time) => {
            if (animationStart === undefined) {
                animationStart = time;
            }

            const elapsedTime = time - animationStart;

            if (elapsedTime < 400) {
                window.requestAnimationFrame(handleAnimation);
            } else {
                detailsElement.removeAttribute('open');
                if (detailsElement.closest('details[open]')) {
                    trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
                }
            }
        };

        window.requestAnimationFrame(handleAnimation);
    }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
    constructor() {
        super();
    }

    openMenuDrawer(summaryElement) {
        this.header = this.header || document.querySelector('.section-header');
        document.documentElement.style.setProperty(
            '--header-bottom-position',
            `${parseInt(this.header.getBoundingClientRect().bottom)}px`,
        );
        this.header.classList.add('menu-open');

        setTimeout(() => {
            this.mainDetailsToggle.classList.add('menu-opening');
        });

        summaryElement.setAttribute('aria-expanded', true);
        window.addEventListener('resize', this.onResize);
        trapFocus(this.mainDetailsToggle, summaryElement);
        document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }

    closeMenuDrawer(event, elementToFocus) {
        if (!elementToFocus) return;
        super.closeMenuDrawer(event, elementToFocus);
        this.header.classList.remove('menu-open');
        window.removeEventListener('resize', this.onResize);
        if (this.mainDetailsToggle) {
            const summary = this.mainDetailsToggle.querySelector('summary');
            if (summary) summary.setAttribute('aria-expanded', false);
        }
    }

    onResize = () => {
        this.header &&
            document.documentElement.style.setProperty(
                '--header-bottom-position',
                `${parseInt(this.header.getBoundingClientRect().bottom)}px`,
            );
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
    constructor() {
        super();
        this.isOpen = false;
        this.sectionId = this.id.replace('PopupModal-', '');
        this.localStorageKey = `${this.sectionId}_popup_shown`;

        this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
        this.addEventListener('keyup', (event) => {
            if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
        if (this.classList.contains('media-modal')) {
            this.addEventListener('pointerup', (event) => {
                if (event.pointerType === 'mouse' && !event.target.closest('deferred-media')) this.hide();
            });
        } else {
            this.addEventListener('click', (event) => {
                if (event.target === this) this.hide();
            });
        }
    }

    connectedCallback() {
        if (this.moved) return;
        this.moved = true;
        document.body.appendChild(this);

        this.setupAutoTrigger();
        this.setupTriggerButtonListener();
    }

    setupAutoTrigger() {
        const modalContent = this.querySelector('.modal-popup__content');
        if (modalContent) {
            const autoTriggerTime = parseInt(modalContent.dataset.autoTriggerTime);
            const storeSession = modalContent.dataset.storeSession === 'true';
            const hasSessionStored = localStorage.getItem(this.localStorageKey) === 'true';

            if (
                autoTriggerTime &&
                autoTriggerTime !== null &&
                autoTriggerTime !== undefined &&
                autoTriggerTime !== NaN &&
                (!storeSession || !hasSessionStored)
            ) {
                this.autoTrigger(autoTriggerTime);
            }
        }
    }

    setupTriggerButtonListener() {
        const modalContent = this.querySelector('.modal-popup__content');
        if (modalContent) {
            const triggerSelector = modalContent.dataset.triggerClass;
            if (triggerSelector) {
                const triggerElements = document.querySelectorAll(triggerSelector);
                triggerElements.forEach((element) => {
                    element.addEventListener('click', (event) => {
                        event.preventDefault();
                        this.show();
                    });
                });
            }
        }
    }

    show(opener) {
        this.isOpen = true;
        const modalContent = this.querySelector('.modal-popup__content');
        const storeSession = modalContent && modalContent.dataset.storeSession === 'true';

        if (storeSession) {
            localStorage.setItem(this.localStorageKey, 'true');
        }

        this.openedBy = opener;
        const popup = this.querySelector('.template-popup');
        document.body.classList.add('overflow-hidden');
        this.setAttribute('open', '');
        if (popup) popup.loadContent();
        trapFocus(this, this.querySelector('[role="dialog"]'));
        document.dispatchEvent(
            new CustomEvent('modal:open', {
                detail: {
                    modal: this,
                },
            }),
        );
        window.pauseAllMedia();
    }

    hide() {
        this.isOpen = false;
        document.body.classList.remove('overflow-hidden');
        document.body.dispatchEvent(new CustomEvent('modalClosed'));
        this.removeAttribute('open');
        removeTrapFocus(this.openedBy);
        document.dispatchEvent(
            new CustomEvent('modal:close', {
                detail: {
                    modal: this,
                },
            }),
        );
        window.pauseAllMedia();
    }

    autoTrigger(delay) {
        setTimeout(() => {
            this.show();
        }, delay);
    }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
    constructor() {
        super();

        const button = this.querySelector('button');

        if (!button) return;
        button.addEventListener('click', () => {
            const modal = document.querySelector(this.getAttribute('data-modal'));
            if (modal.isOpen) {
                button.classList.remove('open');
                modal.hide();
            } else {
                button.classList.add('open');
                modal.show(button);
            }
        });
    }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
    constructor() {
        super();
        const poster = this.querySelector('[id^="Deferred-Poster-"]');
        if (!poster) return;
        poster.addEventListener('click', this.loadContent.bind(this));
    }

    loadContent(focus = true) {
        window.pauseAllMedia();
        if (!this.getAttribute('loaded')) {
            const content = document.createElement('div');
            content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

            this.setAttribute('loaded', true);
            const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
            if (focus) deferredElement.focus();
            if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
                // force autoplay for safari
                deferredElement.play();
            }
        }
    }
}

customElements.define('deferred-media', DeferredMedia);

/** Match dot count to tiny-slider "pages" when using a custom .tiny-slider-counter nav. */
function syncTinySliderCounterToPages(slider, navContainer) {
    if (!slider?.getInfo || !navContainer) return;
    const { pages } = slider.getInfo();
    if (typeof pages !== 'number' || pages < 0) return;
    [...navContainer.children].forEach((child, index) => {
        child.style.display = index < pages ? '' : 'none';
    });
}

class TinySliderConfig {
    generateConfig(element) {
        this.hasNav = element.querySelectorAll('.tiny-slider__nav').length > 0;
        this.navElm = element.querySelector('.tiny-slider__nav');
        this.hasDirectorButtons = element.querySelectorAll('.tiny-slider__buttons').length > 0;
        this.directorButtons = element.querySelectorAll('.tiny-slider__buttons button');
        this.sliderElm = element.querySelector('.tiny-slider__slides');
        this.settingsTemplate = element.querySelector('script[type="text/template"]');
        this.settings = this.settingsTemplate ? JSON.parse(this.settingsTemplate.innerHTML) : undefined;
        this.prevButton = element.querySelector('.slider-button--prev') ?? undefined;
        this.nextButton = element.querySelector('.slider-button--next') ?? undefined;
        this.navContainer = element.querySelector('.tiny-slider-counter') ?? undefined;

        return {
            ...this.settings,
            container: this.sliderElm,
            prevButton: this.prevButton,
            nextButton: this.nextButton,
            navContainer: this.navContainer,
            preventScrollOnTouch: 'auto',
            onInit: this.onInit(),
            navElm: this.navElm,
            hasNav: this.hasNav,
            sliderDirectorButtonsExist: this.hasDirectorButtons,
            sliderDirectorButtons: this.directorButtons,
        };
    }

    onInit() {
        if (this.settings?.mouseDrag) this.sliderElm?.classList.add('tns-mouse-drag');
    }
}

class TinySlider extends HTMLElement {
    constructor() {
        super();
        this.config = new TinySliderConfig().generateConfig(this);

        if (this.config.hasNav) {
            if (this.config.navContainer) {
                this.thumbnails = undefined;
                this.thumbnailCheck();
            } else {
                this.slider = tns({
                    ...this.config,
                    navContainer: this.config.navElm,
                    navAsThumbnails: this.config.hasNav,
                });
            }
        } else {
            this.slider = tns(this.config);
        }

        const useDirectorButtons = this.hasDirectorButtons || this.config.sliderDirectorButtonsExist;
        if (useDirectorButtons) {
            this.slider.events.on('transitionEnd', this.onTransitionEnd.bind(this));
            if (this.directorButtons && this.directorButtons.length > 0) {
                this.directorButtons.forEach((button) =>
                    button.addEventListener('click', this.directorClick.bind(this)),
                );
            } else if (this.config.sliderDirectorButtons && this.config.sliderDirectorButtons.length > 0) {
                this.config.sliderDirectorButtons.forEach((button) =>
                    button.addEventListener('click', this.directorClick.bind(this)),
                );
            }
        }

        this.onInit();

        // Ensure accessibility is set up after DOM is fully ready
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => {
                setTimeout(() => {
                    this.initAriaCheck();
                }, 200);
            });
        } else {
            setTimeout(() => {
                this.initAriaCheck();
            }, 200);
        }
    }

    onInit() {
        this.initThumbnails(this);
        this.initKeyboardControls();

        // Wait for slider to be fully initialized before setting up accessibility
        setTimeout(() => {
            this.initAriaCheck();
        }, 100);

        // Announce slide changes on index change
        this.slider.events.on('indexChanged', (event) => {
            this.announceSlideChange(event.index);
        });

        // Also handle transition end events to update accessibility attributes
        this.slider.events.on('transitionEnd', (event) => {
            // Small delay to ensure content is fully rendered
            setTimeout(() => {
                this.initAriaCheck();
                this.announceSlideChange(event.index);
            }, 100);
        });

        // Also run accessibility check after any slider rebuilds
        this.slider.events.on('init', this.initAriaCheck.bind(this));

        if (this.config.navContainer && !this.config.hasNav) {
            this.slider.events.on('newBreakpointEnd', () => this.syncNavPageDotsVisibility());
            queueMicrotask(() => this.syncNavPageDotsVisibility());
        }
    }

    syncNavPageDotsVisibility() {
        if (!this.config.navContainer || this.config.hasNav) return;
        syncTinySliderCounterToPages(this.slider, this.config.navContainer);
    }

    disconnectedCallback() {
        if (this.handleAutoHeightResize) {
            window.removeEventListener('resize', this.handleAutoHeightResize);
        }
        clearTimeout(this.autoHeightResizeTimeout);
    }

    initAriaCheck() {
        const { slideItems } = this.slider.getInfo();

        if (!slideItems || slideItems.length === 0) {
            // If no slides are available yet, try again after a short delay
            setTimeout(() => {
                this.initAriaCheck();
            }, 50);
            return;
        }

        [...slideItems].forEach((slide, index) => {
            const isActive = slide.classList.contains('tns-slide-active');

            if (isActive) {
                slide.removeAttribute('inert');
                const slideContent = this.getSlideContent(slide);
                const slideCountText = window.sliderStrings.slideCount
                    .replace('[slide_number]', index + 1)
                    .replace('[total_slides]', slideItems.length);
                slide.setAttribute('aria-label', slideCountText + '. ' + slideContent);
            } else {
                slide.setAttribute('inert', '');
            }
        });
    }

    initThumbnails() {
        if (!this.config.hasNav) return;

        this.navSettingsTemplate = this.querySelector('.tiny-slider__nav-script');
        this.navSettings = this.navSettingsTemplate ? JSON.parse(this.navSettingsTemplate.innerHTML) : undefined;

        if (this.thumbnails) {
            this.thumbnails.rebuild();
        } else {
            this.thumbnails = tns({
                ...this.navSettings,
                container: this.config.navElm,
            });

            this.slider.events.on('indexChanged', this.thumbnailsOnChange.bind(this));
            this.thumbnails.events.on('indexChanged', this.thumbnailsOnChange.bind(this));
        }
    }

    thumbnailsOnChange(event) {
        if (this.slider.getInfo().index != event.index) this.slider.goTo(event.index);
        if (this.thumbnails.getInfo().index != event.index) this.thumbnails.goTo(event.index);
    }

    setIsMobile() {
        const originalThis = this;
        var timeout = false,
            delay = 500;
        window.addEventListener('resize', function () {
            clearTimeout(timeout);
            timeout = setTimeout(originalThis.sliderCheck.setMobile(window.innerWidth <= 767), delay);
        });
        this.sliderCheck.setMobile(window.innerWidth <= 767);
    }

    thumbnailCheck() {
        this.sliderCheck = {
            isMobile: window.innerWidth < 768,
            setMobile(val) {
                if (val === this.isMobile) return;
                this.isMobile = val;
                this.mobileListener(val);
            },
            mobileListener: function (val) {},
            registerNewListener: function (externalListenerFunction) {
                this.mobileListener = externalListenerFunction;
            },
        };
        if (this.sliderCheck.isMobile) {
            this.slider = tns({
                ...this.config,
            });
        } else {
            this.slider = tns({
                ...this.config,
                navContainer: this.config.navElm,
                navAsThumbnails: this.config.hasNav,
                onInit: this.initThumbnails.bind(this),
            });
        }

        this.setIsMobile();
        this.sliderCheck.registerNewListener(() => window.location.reload());
    }

    goTo(id) {
        const slide = this.querySelector(id);
        this.slider.goTo(Array.prototype.indexOf.call(slide.parentNode.children, slide));
    }

    onTransitionEnd(event) {
        if (this.directorButtons && this.directorButtons.length > 0) {
            this.directorButtons.forEach((button, i) => {
                event.index === i ? button.classList.add('button--active') : button.classList.remove('button--active');
            });
        } else if (this.config.sliderDirectorButtons && this.config.sliderDirectorButtons.length > 0) {
            this.config.sliderDirectorButtons.forEach((button, i) => {
                event.index === i ? button.classList.add('button--active') : button.classList.remove('button--active');
            });
        }
    }

    directorClick(event) {
        event.preventDefault();
        const targetId = event.target.getAttribute('data-attr');
        if (targetId) {
            this.goTo(targetId);
        }
    }

    initKeyboardControls() {
        // Add keyboard event listeners to the slider container
        this.addEventListener('keydown', this.handleKeyboardNavigation.bind(this));

        // Add focus management
        this.addEventListener('focus', () => {
            // Announce current slide when carousel receives focus
            const { index } = this.slider.getInfo();
            this.announceSlideChange(index);
        });
    }

    handleKeyboardNavigation(event) {
        switch (event.key) {
            case ' ':
            case 'Enter':
                event.preventDefault();
                if (this.config.autoplay) {
                    // Use Tiny Slider's built-in autoplay button
                    const autoplayButton = this.querySelector('[data-controls="autoplay"]');
                    if (autoplayButton) {
                        autoplayButton.click();
                    }
                }
                break;
        }
    }

    announceSlideChange(newIndex) {
        const { slideCount } = this.slider.getInfo();
        const slideItems = this.slider.getInfo().slideItems;
        const currentSlide = slideItems[newIndex];

        if (!currentSlide) return;

        // Get slide content for announcement
        const slideContent = this.getSlideContent(currentSlide);
        const announcement =
            window.sliderStrings.slideCount
                .replace('[slide_number]', newIndex + 1)
                .replace('[total_slides]', slideCount) +
            '. ' +
            slideContent;

        // Create or update live region for announcements
        let liveRegion = this.querySelector('.visually-hidden[aria-live]');
        if (!liveRegion) {
            liveRegion = document.createElement('div');
            liveRegion.className = 'visually-hidden';
            liveRegion.setAttribute('aria-live', 'polite');
            liveRegion.setAttribute('aria-atomic', 'true');
            this.appendChild(liveRegion);
        }

        liveRegion.textContent = announcement;
    }

    getSlideContent(slide) {
        const content = [];

        // Get heading text (prioritize banner heading, then any heading)
        const heading = slide.querySelector('.banner__heading') || slide.querySelector('h1, h2, h3, h4, h5, h6');
        if (heading && heading.textContent.trim()) {
            content.push(heading.textContent.trim());
        }

        // Get description text (prioritize banner text, then any paragraph)
        const description = slide.querySelector('.banner__text') || slide.querySelector('p:not(.banner__disclaimer)');
        if (description && description.textContent.trim()) {
            // Limit description length to avoid overly long announcements
            const descText = description.textContent.trim();
            if (descText.length > 150) {
                content.push(descText.substring(0, 150) + '...');
            } else {
                content.push(descText);
            }
        }

        // Get interactive elements (buttons and links)
        const interactiveElements = slide.querySelectorAll('a[href], button:not(.slider-button)');
        const actionTexts = [];
        interactiveElements.forEach((element) => {
            const text = element.textContent.trim();
            if (text && !actionTexts.includes(text)) {
                actionTexts.push(text);
            }
        });

        if (actionTexts.length > 0) {
            content.push(window.sliderStrings.availableActions.replace('[actions]', actionTexts.join(', ')));
        }

        // If no meaningful content found, provide a generic description
        if (content.length === 0) {
            content.push(window.sliderStrings.genericDescription);
        }

        return content.join('. ');
    }
}

// Override Tiny Slider's automatic tabindex="-1" on nav buttons
function overrideTinySliderTabindex() {
    // Find all Tiny Slider instances
    const sliders = document.querySelectorAll('tiny-slider');

    sliders.forEach((slider) => {
        if (slider) {
            // Override after slider initialization
            const overrideTabindex = () => {
                const prevButton = slider.querySelector('.slider-button--prev');
                const nextButton = slider.querySelector('.slider-button--next');

                if (prevButton && prevButton.getAttribute('tabindex') === '-1') {
                    prevButton.setAttribute('tabindex', '0');
                }
                if (nextButton && nextButton.getAttribute('tabindex') === '-1') {
                    nextButton.setAttribute('tabindex', '0');
                }
            };

            // Run immediately since tns-outer exists
            overrideTabindex();

            // Also run after any rebuilds/reinitializations
            // Use MutationObserver to watch for changes
            const observer = new MutationObserver(() => {
                overrideTabindex();
            });

            observer.observe(slider, {
                childList: true,
                subtree: true,
                attributes: true,
            });
        }
    });
}

// Add keyboard event listeners for Tiny Slider navigation buttons
function addTinySliderKeyboardSupport() {
    const sliders = document.querySelectorAll('tiny-slider');

    sliders.forEach((slider) => {
        const prevButton = slider.querySelector('.slider-button--prev');
        const nextButton = slider.querySelector('.slider-button--next');
        const paginationDots = slider.querySelectorAll('.tiny-slider-counter__link');

        if (prevButton) {
            prevButton.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    prevButton.click();
                }
            });
        }

        if (nextButton) {
            nextButton.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    nextButton.click();
                }
            });
        }

        paginationDots.forEach((dot) => {
            dot.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    dot.click();
                }
            });
        });
    });
}

// Run on DOM ready and after any dynamic content loads
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addTinySliderKeyboardSupport);
    document.addEventListener('DOMContentLoaded', overrideTinySliderTabindex);
} else {
    addTinySliderKeyboardSupport();
    overrideTinySliderTabindex();
}

customElements.define('tiny-slider', TinySlider);

class VariantSelects extends HTMLElement {
    constructor() {
        super();
        this.isCard = this.closest('product-info').dataset.card === 'true';
        this.listOfOptions = null;
        this.availableAndOutOfStockOptions = null;
        this.listOfAvailableOptions = null;
        this.addEventListener('change', this.onVariantChange);
    }

    onVariantChange(event) {
        this.updateOptions();
        this.updateMasterId();
        this.toggleLoading();
        this.removeErrorMessage();
        this.updateVariantStatuses(event.target.dataset.optionPosition);
        if (window.theme.settings.variantWarningEnable) this.updateStrengthWarning();
        document.dispatchEvent(
            new CustomEvent('variant:change', {
                detail: {
                    variant: this.currentVariant,
                },
            }),
        );

        if (!this.currentVariant) {
            this.toggleLoading();
            this.setUnavailable();
        } else {
            this.updateMedia();
            this.updateURL();
            this.updateVariantInput();
            this.renderProductInfo();
        }
    }

    updateOptions() {
        this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }

    updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options
                .map((option, index) => {
                    return this.options[index] === option;
                })
                .includes(false);
        });
    }

    generateCardImage(image) {
        const cardImage = document.createElement('IMG');
        cardImage.src = image.preview_image.src;
        cardImage.dataset.id = image.id;
        return cardImage;
    }

    updateCardImage(cardContent, image) {
        cardContent.querySelectorAll('img').forEach((existingImage) => {
            existingImage.classList.add('hidden');
        });

        if (image) {
            const hasImage = cardContent.querySelector(`img[data-id="${image.id}"]`);
            if (hasImage) {
                hasImage.classList.remove('hidden');
            } else {
                cardContent.prepend(this.generateCardImage(this.currentVariant.featured_media));
            }
        } else {
            const defaultImage = cardContent.querySelector(`.card__media--default`);
            defaultImage.classList.remove('hidden');
        }
    }

    updateMedia() {
        if (!this.currentVariant) return;

        const cardContent = document.querySelector(`#ProductCard-${this.dataset.section} .card__media .media`);
        if (cardContent) this.updateCardImage(cardContent, this.currentVariant.featured_media);

        if (!this.currentVariant.featured_media) return;

        const srcArray = this.currentVariant.featured_media['preview_image'].src.split('/');
        const imageWithoutFileName = srcArray.slice(0, -1);
        const imageWithoutFileNameString = imageWithoutFileName.join('/');
        const fileNameString = srcArray[srcArray.length - 1].replace('.', '_250x250.');
        const imageSrc = imageWithoutFileNameString + '/' + fileNameString;

        if (document.querySelector('.product-drawer__wrapper .product__content-image img')) {
            document.querySelector('.product-drawer__wrapper .product__content-image img')?.remove();
            document.querySelector('.product-drawer__wrapper .product__content-image').innerHTML = `
            <img
                src="${imageSrc}"
                alt="${this.currentVariant.featured_media.alt ? this.currentVariant.featured_media.alt : ''}"
                width="100"
                height="100"
            />`;
        }

        const mediaGalleries = document.querySelectorAll(`[id^="GalleryViewer-${this.dataset.section}"]`);
        mediaGalleries.forEach((mediaGallery) => {
            mediaGallery.goTo(`div[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`);
        });
    }

    updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateStrength(callback) {
        const productForms = document.querySelectorAll(
            `#product-form-${this.dataset.section}, #quick-add-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
        );
        productForms.forEach((productForm) => {
            const productFormTag = productForm.parentElement;
            let strengthIndex = null;

            if (productFormTag.dataset.analyticsStrengthIndex) {
                strengthIndex = parseInt(productFormTag.dataset.analyticsStrengthIndex);
            }
            callback(productFormTag, this.currentVariant.options[strengthIndex]);
        });
    }

    updateVariantInput() {
        this.updateStrength((productFormTag, strength) => {
            productFormTag.dataset.analyticsStrength = strength;
            productFormTag.dataset.analyticsVariant = this.currentVariant.title;

            const input = productFormTag.querySelector('input[name="id"]');
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }

    updateOptionStatus(option, inputWrappers, index) {
        const selectedOptionOneVariants = this.variantData.filter(
            (variant) => this.querySelector(':checked').value === variant.option1,
        );
        const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
        const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
        const availableOptionInputsValue = selectedOptionOneVariants
            .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
            .map((variantOption) => variantOption[`option${index + 1}`]);
        const availableAndOutOfStockOptionInputsValue = selectedOptionOneVariants.map(
            (variantOption) => variantOption[`option${index + 1}`],
        );

        this.listOfOptions = optionInputs;
        this.listOfAvailableOptions = availableOptionInputsValue;
        this.availableAndOutOfStockOptions = availableAndOutOfStockOptionInputsValue;
    }

    updateVariantStatuses(changedPosition) {
        const inputWrappers = [...this.querySelectorAll('.product-form__input')];

        inputWrappers.forEach((option, index) => {
            if (index === 0) return;

            this.updateOptionStatus(option, inputWrappers, index);
            this.setInputAvailability();
            if (parseInt(changedPosition) === 1) this.triggerChange();
        });

        if (parseInt(changedPosition) === 1) this.dispatchEvent(new Event('change'));
    }

    setInputAvailability() {
        this.listOfOptions.forEach((input) => {
            if (this.availableAndOutOfStockOptions.includes(input.getAttribute('value'))) {
                input.innerText = input.getAttribute('value');
            } else {
                input.innerText = window.variantStrings.unavailable_with_option.replace(
                    '[value]',
                    input.getAttribute('value'),
                );
            }
        });
    }

    renderStrengthWarning() {
        const warning = document.createElement('DIV');
        warning.classList.add('variant-warning');
        warning.innerHTML = window.productStrings.variantWarning;
        return warning;
    }

    updateStrengthWarning() {
        this.updateStrength((productFormTag, strength) => {
            const strengthInt = parseInt(strength);
            const currentWarning = this.querySelector('.variant-warning');

            if (strengthInt < 14) {
                if (currentWarning) currentWarning.remove();
                return;
            }

            const warning = this.renderStrengthWarning();
            const strengthSelector = this.querySelector('.label--strength').closest(
                '.product-variant-options__wrapper',
            );

            if (!currentWarning) strengthSelector.parentNode.insertBefore(warning, strengthSelector.nextSibling);
        });
    }

    removeErrorMessage() {
        const section = this.closest('section');
        if (!section) return;

        const productForm = section.querySelector('product-form');
        if (productForm) productForm.handleErrorMessage();
    }

    renderProductInfo() {
        const isCard = this.isCard;
        const requestedVariantId = this.currentVariant.id;
        const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
        const fetchURL = isCard
            ? `${this.dataset.url}?variant=${requestedVariantId}&view=card`
            : `${this.dataset.url}?variant=${requestedVariantId}&section_id=${sectionId}`;

        fetch(fetchURL)
            .then((response) => response.text())
            .then((responseText) => {
                // prevent unnecessary ui changes from abandoned selections
                if (this.currentVariant.id !== requestedVariantId) return;

                const rawHtml = new DOMParser().parseFromString(responseText, 'text/html');
                const html = rawHtml;
                const sourceSectionId = isCard
                    ? rawHtml.querySelector('product-info').getAttribute('data-section')
                    : sectionId;

                const destination = document.getElementById(`price-${this.dataset.section}`);
                const source = html.getElementById(`price-${sourceSectionId}`);
                const drawerDescriptionSource = html.getElementById(`drawer-description-${sourceSectionId}`);
                const drawerDescriptionDestination = document.getElementById(
                    `drawer-description-${this.dataset.section}`,
                );
                const subscriptionSource = html.getElementById(`subscription-${sourceSectionId}`);
                const subscriptionDestination = document.getElementById(`subscription-${this.dataset.section}`);
                const reviewsSource = html.querySelectorAll(`.js-reviews-${sourceSectionId}`);
                const reviewsDestination = document.querySelectorAll(`.js-reviews-${this.dataset.section}`);
                const skuSource = html.getElementById(`Sku-${sourceSectionId}`);
                const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
                const inventorySource = html.getElementById(`Inventory-${sourceSectionId}`);
                const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);
                const multiBuyButtonsSource = html.getElementById(`multi-buy-buttons-${sourceSectionId}`);
                const multiBuyButtonsDestination = document.getElementById(`multi-buy-buttons-${this.dataset.section}`);

                if (source && destination) destination.innerHTML = source.innerHTML;

                if (multiBuyButtonsSource && multiBuyButtonsDestination) {
                    multiBuyButtonsDestination.innerHTML = multiBuyButtonsSource.innerHTML;
                }
                if (subscriptionSource && subscriptionDestination)
                    subscriptionDestination.innerHTML = subscriptionSource.innerHTML;
                if (drawerDescriptionSource && drawerDescriptionDestination) {
                    drawerDescriptionDestination.innerHTML = drawerDescriptionSource.innerHTML;
                    drawerDescriptionDestination.classList.remove('hidden');
                }
                if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
                if (skuSource && skuDestination) {
                    skuDestination.innerHTML = skuSource.innerHTML;
                    skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
                }
                if (reviewsSource && reviewsDestination) {
                    reviewsSource.forEach((source, index) => {
                        reviewsDestination[index].innerHTML = source.innerHTML;
                    });
                }

                const price = document.getElementById(`price-${this.dataset.section}`);

                if (price) price.classList.remove('hidden');

                if (inventoryDestination)
                    inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

                const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sourceSectionId}`)
                    ? html.getElementById(`ProductSubmitButton-${sourceSectionId}`)
                    : html.getElementById(`ProductSubmitButton-${sourceSectionId}__${this.dataset.id}`);

                this.toggleAddButton(
                    addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
                    window.variantStrings.soldOut,
                );
                this.toggleLoading();

                sendAnalyticsEventData(USER_INTERACTION_ANALYTICS_EVENTS.variantChange, {
                    data: {
                        sectionId,
                        html,
                        variant: this.currentVariant,
                    },
                });
            });
    }

    toggleLoading() {
        const productForm = document.getElementById(`ProductInfo-${this.dataset.section}`)
            ? document.getElementById(`ProductInfo-${this.dataset.section}`)
            : document.getElementById(`quick-add-${this.dataset.section}`);
        if (!productForm) return;
        const productCard = productForm.closest('.card');

        productCard
            ? productCard.classList.toggle('card--loading')
            : productForm.classList.toggle('product__info-container--loading');
    }

    toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(`product-form-${this.dataset.section}`)
            ? document.getElementById(`product-form-${this.dataset.section}`)
            : document.getElementById(`quick-add-${this.dataset.section}`);
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        if (!addButton) return;

        if (disable) {
            addButton.setAttribute('disabled', 'disabled');
            const selectedVariant = document.querySelector('.product-form__input input[type=radio].disabled:checked');
            if (selectedVariant) {
                const customUnavailableMessage = selectedVariant.dataset.customUnavailableMessage;
                if (customUnavailableMessage) {
                    text = customUnavailableMessage;
                }
            }
            if (text) addButtonText.textContent = text;
        } else {
            addButton.removeAttribute('disabled');
            addButtonText.textContent = window.variantStrings.addToCart;
        }

        if (!modifyClass) return;
    }

    setUnavailable() {
        const drawerDescription = document.getElementById(`drawer-description-${this.dataset.section}`);
        const button = document.getElementById(`product-form-${this.dataset.section}`);
        const addButton = button.querySelector('[name="add"]');
        const addButtonText = button.querySelector('[name="add"] > span');
        const price = document.getElementById(`price-${this.dataset.section}`);
        const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
        const sku = document.getElementById(`Sku-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
        const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

        if (drawerDescription) drawerDescription.classList.add('hidden');

        if (!addButton) return;
        addButton.setAttribute('disabled', 'disabled');
        addButtonText.textContent = window.variantStrings.unavailable;
        if (price) price.classList.add('hidden');
        if (inventory) inventory.classList.add('hidden');
        if (sku) sku.classList.add('hidden');
        if (volumeNote) volumeNote.classList.add('hidden');
        if (volumeTable) volumeTable.classList.add('hidden');
        if (qtyRules) qtyRules.classList.add('hidden');
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
    constructor() {
        super();
    }

    isAvailable(value) {
        const isOutOfStock =
            this.availableAndOutOfStockOptions.includes(value) && !this.listOfAvailableOptions.includes(value);

        return {
            stock: isOutOfStock,
            status: !(isOutOfStock || !this.listOfAvailableOptions.includes(value)),
        };
    }

    setInputAvailability() {
        this.listOfOptions.forEach((input) => {
            const inputLabel = input.nextElementSibling;
            const available = this.isAvailable(input.getAttribute('value'));

            if (available.stock) {
                input.classList.add('disabled');
                input.classList.remove('hidden');
                inputLabel.classList.remove('hidden');
            } else if (!this.listOfAvailableOptions.includes(input.getAttribute('value'))) {
                input.classList.add('hidden');
                inputLabel.classList.add('hidden');
                input.classList.remove('disabled');
            } else {
                input.classList.remove('disabled');
                input.classList.remove('hidden');
                inputLabel.classList.remove('hidden');
            }
        });
    }

    requiresChange() {
        let firstAvailable = this.listOfOptions.find((input) => this.isAvailable(input.getAttribute('value')).status);
        const selectedOption = this.listOfOptions.find((input) => input.checked);
        if (firstAvailable === undefined)
            firstAvailable = this.listOfOptions.find((input) => input.value == this.availableAndOutOfStockOptions[0]);

        return {
            firstAvailable: firstAvailable,
            selectedOption: selectedOption,
            required: selectedOption != firstAvailable && this.listOfAvailableOptions.length > 0,
        };
    }

    triggerChange() {
        const changeCheck = this.requiresChange();
        if (changeCheck.selectedOption != changeCheck.firstAvailable) {
            if (changeCheck.firstAvailable) {
                changeCheck.firstAvailable.checked = true;
            } else {
                this.listOfOptions[0].checked = true;
            }
        }
    }

    updateOptions() {
        const selectedValues = this.querySelectorAll('.product-form__input-active');
        if (!selectedValues) return;
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        this.options = fieldsets.map((fieldset, index) => {
            if (selectedValues[index])
                selectedValues[index].textContent = Array.from(fieldset.querySelectorAll('input')).find(
                    (radio) => radio.checked,
                ).value;

            return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
        });
    }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.fetchRecommendations((response) => {
            const html = document.createElement('div');
            html.innerHTML = response;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
                this.innerHTML = recommendations.innerHTML;
                if (this.querySelector('.tiny-slider__slides')) {
                    this.config = new TinySliderConfig().generateConfig(this);
                    this.slider = tns(this.config);
                    if (document.querySelector('quick-add-drawer')) {
                        document.querySelector('quick-add-drawer').setQuickAddLinkClicks();
                    }
                }
            }
            this.querySelector('.related-products').classList.remove('related-products--loading');
        });
    }

    async fetchRecommendations(callback) {
        fetch(this.dataset.url)
            .then((response) => response.text())
            .then((response) => {
                callback(response);
            })
            .catch((e) => {
                console.error(e);
            });
    }
}

customElements.define('product-recommendations', ProductRecommendations);

// todo: Add the form validation here
class FormValidation extends HTMLElement {
    constructor() {
        super();
        this.validation = window.validation[Shopify.country];
        this.form = this.querySelector('form');
        this.form.addEventListener('submit', this.handleValidation.bind(this));
        this.inputs = this.querySelectorAll('input, select');
        this.formError = this.querySelector('.global-message--error');
        this.formErrorContent = this.querySelector('.global-message--error .global-message__copy');
        this.hasValidated = false;
        this.validationStatus = [];
        this.inputEvents = [];

        this.inputs.forEach((input) => {
            if (input.readOnly || !input.required || this.checkPhoneEligibility(input)) return;
            if (input.getAttribute('type') === 'checkbox') input.checked = false;
            const inputValidation = this.validationCheck(input);
            const changeFunction = this.inputChange.bind(this);

            this.validationStatus.push({
                input: input,
                status: inputValidation.status,
            });
            this.inputEvents.push({
                input: input,
                function: changeFunction,
            });
            input.addEventListener('input', changeFunction);
        });

        this.addEventListener('form-validation:add-input', (event) => {
            this.addValidationAndListeners(event.detail.input);
        });
        this.addEventListener('form-validation:remove-input', (event) => {
            this.removeValidationAndListeners(event.detail.input);
        });

        this.toggleManualAddress = this.querySelector('.js-address-manual');
        if (this.toggleManualAddress) this.toggleManualAddress.addEventListener('click', this.toggleAddress.bind(this));
    }

    toggleAddress(event) {
        event.preventDefault();

        const quickAddressDiv = this.querySelector('.form-field__container-quick-address');
        const quickAddressInput = quickAddressDiv.querySelector('input');
        if (quickAddressDiv) {
            quickAddressDiv.classList.add('hidden');
            this.removeValidationAndListeners(quickAddressInput);
        }

        const addressFieldsDiv = document.querySelector('.address-fields');
        if (addressFieldsDiv) {
            addressFieldsDiv.classList.remove('hidden');
        }
        return;
    }

    checkPhoneEligibility(input) {
        if (input.getAttribute('type') !== 'tel') return false;

        const togglePhoneCheckbox = this.querySelector('input[name="no_phone_number"]');
        if (!togglePhoneCheckbox) return;

        if (togglePhoneCheckbox && !this.togglePhoneCheckboxInitialized) {
            togglePhoneCheckbox.addEventListener('change', () => this.togglePhoneCheck(togglePhoneCheckbox));
            this.togglePhoneCheckboxInitialized = true;
        }

        input.readOnly = togglePhoneCheckbox?.checked || false;
        return togglePhoneCheckbox?.checked || false;
    }

    togglePhoneCheck(checkbox) {
        this.querySelectorAll('input[type="tel"]').forEach((input) => {
            input.readOnly = checkbox.checked;

            if (checkbox.checked) {
                input.value = '';
                this.removeError(input);
                this.removeValidationAndListeners(input);
            } else {
                this.addValidationAndListeners(input);
            }
        });
    }

    removeValidationAndListeners(input) {
        const eventIndex = this.inputEvents.findIndex((event) => event.input === input);
        if (eventIndex !== -1) {
            input.removeEventListener('input', this.inputEvents[eventIndex].function);
            this.inputEvents.splice(eventIndex, 1);
        }
        const validationIndex = this.validationStatus.findIndex((validation) => validation.input === input);
        if (validationIndex !== -1) {
            this.validationStatus.splice(validationIndex, 1);
        }
    }

    addValidationAndListeners(input) {
        if (
            this.validationStatus.filter((status) => status.input === input).length > 0 &&
            this.inputEvents.filter((event) => event.input === input).length > 0
        ) {
            this.removeValidationAndListeners(input);
        }
        const changeFunction = this.inputChange.bind(this);
        const inputValidation = this.validationCheck(input);
        this.validationStatus.push({ input: input, status: inputValidation.status });
        this.inputEvents.push({ input: input, function: changeFunction });
        input.addEventListener('input', changeFunction);
    }

    renderErrorMessage(container, errorString) {
        const existingMessage = container.querySelector('.form-field__message--error');
        const newErrorMessage = errorString ?? window.validationStrings.required;
        if (existingMessage && existingMessage.textContent === newErrorMessage) return;

        existingMessage?.remove();
        const errorMessage = document.createElement('DIV');

        errorMessage.classList.add(...['form-field__message', 'form-field__message--error']);
        errorMessage.textContent = newErrorMessage;

        if (container.querySelector('.form-field__footer')) {
            container.querySelector('.form-field__footer').prepend(errorMessage);
        } else {
            container.append(errorMessage);
        }
    }

    removeError(input) {
        if (input.getAttribute('type') === 'checkbox') {
            this.validationStatus.forEach((part) => {
                if (part.input.getAttribute('name') === input.getAttribute('name')) part.status = true;
            });
        } else {
            this.validationStatus.find((part) => part.input === input).status = true;
        }

        // Removal of attribute only works on a timeout
        setTimeout(() => {
            const container = input.closest('.form-field__container');
            container.querySelector('.form-field__message--error')?.remove();
            container.classList.remove('form-field--error');
        });
    }

    flagError(input, errorMessage) {
        if (input.getAttribute('type') === 'checkbox') {
            this.validationStatus.forEach((part) => {
                if (part.input.getAttribute('name') === input.getAttribute('name')) part.status = false;
            });
        } else {
            this.validationStatus.find((part) => part.input === input).status = false;
        }

        const container = input.closest('.form-field__container');
        this.renderErrorMessage(container, errorMessage);
        container.classList.add('form-field--error');
    }

    validateMinMax(input) {
        const min = parseInt(input.getAttribute('min')) || undefined;
        const max = parseInt(input.getAttribute('max')) || undefined;
        const length = input.value.length;

        return {
            status: (min === undefined || length >= min) && (max === undefined || length <= max),
            min: min === undefined || length >= min,
            max: max === undefined || length <= max,
        };
    }

    emailValidate(input) {
        const value = input.value;
        const length = value.length;
        const re = /^[A-zÀ-ú0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        const isEmail = re.test(value);

        const getErrorMessage = () => {
            if (length <= 0) {
                return window.validationStrings.required;
            } else if (length > this.validation.length.email) {
                return window.validationStrings.max_length.generic.replace(
                    '{{ length }}',
                    this.validation.length.email,
                );
            } else if (!isEmail) {
                return window.validationStrings.invalid.email;
            }
        };

        if (length <= 0 || !isEmail || length > this.validation.length.email) {
            return {
                status: false,
                message: getErrorMessage(),
            };
        } else {
            return {
                status: true,
            };
        }
    }

    phoneValidate(input) {
        const value = input.value.startsWith(this.validation.phone.prefix)
            ? input.value
            : `${this.validation.phone.prefix}${input.value}`;
        const length = value.length;
        const re = new RegExp(this.validation.phone.regex);
        const isPhone = re.test(value);

        const getErrorMessage = () => {
            if (length < this.validation.phone.min) {
                return window.validationStrings.min_length.replace('{{ length }}', this.validation.phone.min);
            } else if (length > this.validation.phone.max) {
                return window.validationStrings.max_length.generic.replace('{{ length }}', this.validation.phone.max);
            } else if (!isPhone) {
                return window.validationStrings.invalid.phone;
            }
        };

        if (length < this.validation.phone.min || length > this.validation.phone.max || !isPhone) {
            return {
                status: false,
                message: getErrorMessage(),
            };
        } else {
            return {
                status: true,
            };
        }
    }

    isOldEnough(value) {
        const getAge = (birthDate) => {
            const today = new Date();
            let age = today.getFullYear() - birthDate.getFullYear();
            const monthDiff = today.getMonth() - birthDate.getMonth();
            if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }
            return age;
        };

        var parts = value.split('/');

        var day = parseInt(parts[0]);
        var month = parseInt(parts[1]) - 1; // Month starts from 0 (January is 0)
        var year = parseInt(parts[2]);

        // Create a Date object for the entered date
        var enteredDate = new Date(year, month, day);
        const age = getAge(enteredDate);

        if (isNaN(age)) return false;

        return {
            state: age >= 18 && age < 100,
            age,
        };
    }

    dobValidate(input) {
        const value = input.value.split('-').reverse().join('/');
        const re = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/(19|20)\d{2}$/;
        const isDate = re.test(value);
        const isOldEnough = this.isOldEnough(value);

        const getErrorMessage = () => {
            if (!isDate) {
                return window.validationStrings.invalid.dob;
            } else if (!isOldEnough.state) {
                if (isOldEnough.age > 100) {
                    return window.validationStrings.invalid.dob_over_age;
                } else if (isOldEnough.age <= 0) {
                    return window.validationStrings.invalid.dob_future_age;
                } else {
                    return window.validationStrings.invalid.dob_inelegible;
                }
            }
        };

        if (!isDate || !isOldEnough.state) {
            return {
                status: false,
                message: getErrorMessage(),
            };
        } else {
            return {
                status: true,
            };
        }
    }

    textValidate(input) {
        const isCorrectLength = this.validateMinMax(input);

        const getErrorMessage = () => {
            if (!isCorrectLength.max) {
                return window.validationStrings.max_length.generic.replace('{{ length }}', input.getAttribute('max'));
            } else if (!isCorrectLength.min) {
                return window.validationStrings.min_length.replace('{{ length }}', input.getAttribute('min'));
            }
        };

        if (!isCorrectLength.status || input.value.length <= 0) {
            return {
                status: false,
                message: getErrorMessage(),
            };
        } else {
            return {
                status: true,
            };
        }
    }

    postcodeValidate(input) {
        const value = input.value;
        const lengthSpaces = value.replace(/ /g, '');
        const length = lengthSpaces.length;
        const re = new RegExp(this.validation.postcode.regex);
        const isPostcode = re.test(value);

        const getErrorMessage = () => {
            if (length <= 0) {
                return window.validationStrings.required;
            } else if (length > this.validation.postcode.max) {
                return window.validationStrings.max_length.postcode;
            } else if (!isPostcode) {
                return window.validationStrings.invalid.postcode;
            }
        };

        if (length <= 0 || length > this.validation.postcode.max || !isPostcode) {
            return {
                status: false,
                message: getErrorMessage(),
            };
        } else {
            return {
                status: true,
            };
        }
    }

    selectValidate(input) {
        const value = input.value;
        const length = value.length;

        const getErrorMessage = () => {
            if (length <= 0 || value === '---') {
                return window.validationStrings.required;
            }
        };

        if (length <= 0 || value === '---') {
            return {
                status: false,
                message: getErrorMessage(),
            };
        } else {
            return {
                status: true,
            };
        }
    }

    checkboxValidate(input) {
        const inputName = input.getAttribute('name');
        const allCheckbox = this.querySelectorAll(`input[type="checkbox"][name="${inputName}"]`);
        const isChecked = Array.from(allCheckbox).filter((checkbox) => checkbox.checked).length > 0;

        if (!isChecked) {
            return {
                status: false,
                message: null,
            };
        } else {
            return {
                status: true,
            };
        }
    }

    addressValidate(input) {
        const inputName = input.getAttribute('name').split('[')[1].split(']')[0];
        const value = input.value;
        const length = value.length;
        const maxLength = this.validation.length[inputName] ?? undefined;

        const getErrorMessage = () => {
            if (length > maxLength ?? false) {
                return window.validationStrings.max_length.generic.replace('{{ length }}', maxLength);
            } else {
                return window.validationStrings.required;
            }
        };

        if (length <= 0 || (length > maxLength ?? false)) {
            return {
                status: false,
                message: getErrorMessage(),
            };
        } else {
            return {
                status: true,
            };
        }
    }

    passwordComplianceValidation(value) {
        let compliant = 0;
        if (value.length < 8) compliant = 0;
        else {
            let expressions = [/[a-z]+/, /[0-9]+/, /[A-Z]+/, /[!@£#$%^&()<>_=+\-]+/];
            expressions.forEach((expression) => {
                if (value.match(expression)) compliant++;
            });
        }
        return compliant >= 3;
    }

    passwordValidate(input) {
        const value = input.value;
        const length = value.length;

        const getErrorMessage = () => {
            if (length <= 0) {
                return window.validationStrings.required;
            }
        };

        if (length <= 0) {
            return {
                status: false,
                message: getErrorMessage(),
            };
        } else {
            return {
                status: true,
            };
        }
    }

    generateStrengthIndicator(input) {
        let strength = 0;
        const container = input.closest('.form-field__container');
        // const label = container.querySelector('.strength-label');
        const label_value = container.querySelector('.strength-label span');
        const validator = container.querySelector('.strength-indicator');
        const value = input.value;
        const isCompliant = this.passwordComplianceValidation(value);
        const expressions = [/.{8,}/, /[a-z]+/, /[0-9]+/, /[A-Z]+/, /.{12,}/, /[!@£#$%^&()<>_=+\-]+/];

        expressions.forEach((regexp) => {
            if (value.match(regexp)) strength++;
        });

        if (value.length > 0) {
            if (strength >= 4 && isCompliant) {
                label_value.textContent = window.validationStrings.strength.strong;
                label_value.classList.remove('strength-label__value--weak');
                label_value.classList.add('strength-label__value--strong');
            } else {
                label_value.textContent = window.validationStrings.strength.weak;
                label_value.classList.remove('strength-label__value--strong');
                label_value.classList.add('strength-label__value--weak');
            }

            value.length >= 8
                ? validator
                      .querySelector('.strength-indicator__item--chars')
                      .classList.add('strength-indicator__item--active')
                : validator
                      .querySelector('.strength-indicator__item--chars')
                      .classList.remove('strength-indicator__item--active');
            value.match(/[a-z]+/)
                ? validator
                      .querySelector('.strength-indicator__item--lower')
                      .classList.add('strength-indicator__item--active')
                : validator
                      .querySelector('.strength-indicator__item--lower')
                      .classList.remove('strength-indicator__item--active');
            value.match(/[A-Z]+/)
                ? validator
                      .querySelector('.strength-indicator__item--upper')
                      .classList.add('strength-indicator__item--active')
                : validator
                      .querySelector('.strength-indicator__item--upper')
                      .classList.remove('strength-indicator__item--active');
            value.match(/[0-9]+/)
                ? validator
                      .querySelector('.strength-indicator__item--numbers')
                      .classList.add('strength-indicator__item--active')
                : validator
                      .querySelector('.strength-indicator__item--numbers')
                      .classList.remove('strength-indicator__item--active');
            value.match(/[!@£#$%^&()<>_=+\-]+/)
                ? validator
                      .querySelector('.strength-indicator__item--special')
                      .classList.add('strength-indicator__item--active')
                : validator
                      .querySelector('.strength-indicator__item--special')
                      .classList.remove('strength-indicator__item--active');
        }
        if (strength >= 4 && isCompliant) {
            validator.classList.add('hidden');
        } else {
            validator.classList.remove('hidden');
        }
    }

    password(input) {
        const container = input.closest('.form-field__container');
        const value = input.value;
        const length = value.length;
        const isCompliant = this.passwordComplianceValidation(value);

        if (container.querySelectorAll('.strength-indicator').length > 0) this.generateStrengthIndicator(input);

        const getErrorMessage = () => {
            if (length <= 0) {
                return window.validationStrings.required;
            } else if (!isCompliant) {
                return '';
            }
        };

        if (length <= 0 || !isCompliant) {
            return {
                status: false,
                message: getErrorMessage(),
            };
        } else {
            return {
                status: true,
            };
        }
    }

    confirm(input) {
        const passwordField = this.validationStatus.find(
            (validation) => validation.input.getAttribute('name') === 'customer[password]',
        );
        const passwordFieldValue = passwordField.input.value;
        const value = input.value;
        const length = value.length;

        const getErrorMessage = () => {
            if (length <= 0) {
                return window.validationStrings.required;
            } else if (passwordFieldValue != value) {
                return window.validationStrings.passwords_no_match;
            }
        };

        if (length <= 0 || passwordFieldValue != value) {
            return {
                status: false,
                message: getErrorMessage(),
            };
        } else {
            return {
                status: true,
            };
        }
    }

    confirmPasswordValidate(input) {
        const isConfirm = input.getAttribute('name') === 'customer[password_confirmation]';
        return isConfirm ? this.confirm(input) : this.password(input);
    }

    validationCheck(input) {
        const passwordValid = () => {
            if (
                this.validationStatus.find(
                    (validation) => validation.input.getAttribute('name') === 'customer[password_confirmation]',
                )
            ) {
                return this.confirmPasswordValidate(input);
            } else {
                return this.passwordValidate(input);
            }
        };

        let inputType = input.getAttribute('type');
        const inputName = input.getAttribute('name');
        if (!inputType && input.tagName === 'SELECT') inputType = 'select';

        if (inputName == 'customer[password]' || inputName == 'customer[password_confirmation]')
            return passwordValid(input);

        switch (inputType) {
            case 'text':
                switch (inputName) {
                    case 'dob':
                        return this.dobValidate(input);
                    case 'address[zip]':
                        return this.postcodeValidate(input);
                    default:
                        if (inputName?.includes('address[')) {
                            return this.addressValidate(input);
                        } else {
                            return this.textValidate(input);
                        }
                }
            case 'email':
                return this.emailValidate(input);
            case 'tel':
                return this.phoneValidate(input);
            case 'password':
                return passwordValid(input);
            case 'checkbox':
                return this.checkboxValidate(input);
            case 'select':
                switch (inputName) {
                    case 'address[country]':
                    case 'address[province]':
                        return this.selectValidate(input);
                }
        }

        return {
            status: false,
            message: null,
        };
    }

    flagInput(validation, input) {
        if (validation.status) {
            this.removeError(input);
        } else {
            this.flagError(input, validation.message);
        }
    }

    inputChange(event) {
        if (!event.target.required) return;
        const inputValidation = this.validationCheck(event.target);
        this.flagInput(inputValidation, event.target);
    }

    triggerFormError() {
        if (!this.formError) return;
        this.formError.classList.add('global-message--active');
        this.formErrorContent.textContent = window.validationStrings.generic;
    }

    removeFormError() {
        if (!this.formError) return;
        this.formError.classList.remove('global-message--active');
    }

    handleValidation(event) {
        event.preventDefault();
        const failedFields = this.validationStatus.filter((part) => part.status === false);
        if (failedFields.length > 0) {
            this.hasValidated = false;
            this.triggerFormError();
            failedFields.forEach((validation) => this.flagInput(validation, validation.input));
        } else {
            this.hasValidated = true;
            this.removeFormError();
        }
    }
}

customElements.define('form-validation', FormValidation);

class PhoneField extends HTMLElement {
    constructor() {
        super();
        this.validation = window.validation[Shopify.country];
        this.prefixElement = this.querySelector('.form-field__prefix');
        this.inputElement = this.querySelector('.form-field__input');
    }

    connectedCallback() {
        this.prefixElement.textContent = this.validation.phone.prefix;
        this.removePrefixFromExistingValue();
    }

    removePrefixFromExistingValue() {
        if (this.inputElement.value.startsWith(this.validation.phone.prefix)) {
            this.inputElement.value = this.inputElement.value.replace(this.validation.phone.prefix, '');
        }
    }
}

customElements.define('phone-field', PhoneField);

class InputCounter extends HTMLElement {
    constructor() {
        super();
        this.validation = window.validation[Shopify.country];
        this.input = this.querySelector('input');
        this.inputName = this.input.getAttribute('name').split('[')[1].split(']')[0];
        this.maxLength = this.validation.length[this.inputName] ?? undefined;
        this.container = this.querySelector('.form-field-counter');
        this.current = this.querySelector('.form-field-counter__current');
        this.max = this.querySelector('.form-field-counter__max');

        this.input.addEventListener('input', this.updateCounter.bind(this));
        this.input.addEventListener('keypress', this.preventType.bind(this));
    }

    connectedCallback() {
        if (!this.maxLength) return;

        if (this.container) this.container.classList.remove('hidden');
        if (this.current) this.current.textContent = this.input.value.length;
        if (this.max) this.max.textContent = this.maxLength;
    }

    preventType(event) {
        if (event.target.value.length >= this.maxLength) event.preventDefault();
    }

    updateCounter() {
        const value = this.input.value;
        const length = value.length;

        if (this.current) this.current.textContent = length;
    }
}

customElements.define('input-counter', InputCounter);

class CountryProvinceField extends HTMLElement {
    constructor() {
        super();
        this.country = this.querySelector('select[name="address[country]"]');
        this.province = this.querySelector('select[name="address[province]"]');

        this.country.value = window.validation.country;
        this.country.addEventListener('input', this.renderProvinces.bind(this));

        this.renderCountry();
        this.renderProvinces();
    }

    renderCountry() {
        const opts = this.country.querySelectorAll('option');
        let defaultProvince = this.country.dataset.default ? this.country.dataset.default : [...opts][0].value;

        const options = [...opts].map((opt) => opt.value);
        const defaultOption = options.indexOf(defaultProvince);
        if (!opts[defaultOption]) return;
        opts[defaultOption].setAttribute('selected', 'selected');
        this.dispatchEvent(
            new CustomEvent('form-validation:add-input', {
                bubbles: true,
                detail: {
                    input: this.country,
                },
            }),
        );
    }

    renderProvinces() {
        const opt = this.country.querySelectorAll('option')[this.country.selectedIndex];
        const defaultProvince = this.province.dataset.default;
        if (!opt) return;

        const raw = opt.getAttribute('data-provinces');
        const provinces = JSON.parse(raw);
        while (this.province.firstChild) {
            this.province.removeChild(this.province.firstChild);
        }

        if (provinces.length) {
            this.province.closest('.form-field__container').classList.remove('hidden');
            this.province.removeAttribute('disabled');
            this.province.setAttribute('required', 'required');
            const province_default_opt = document.createElement('option');
            province_default_opt.value = '---';
            province_default_opt.textContent = '---';
            if (!defaultProvince) province_default_opt.setAttribute('selected', 'selected');
            this.province.append(province_default_opt);
            for (var i = 0; i < provinces.length; i++) {
                const province_opt = document.createElement('option');
                province_opt.value = provinces[i][0];
                province_opt.textContent = provinces[i][1];
                if (provinces[i][0] === defaultProvince) province_opt.setAttribute('selected', 'selected');
                this.province.append(province_opt);
            }

            this.dispatchEvent(
                new CustomEvent('form-validation:add-input', {
                    bubbles: true,
                    detail: {
                        input: this.province,
                    },
                }),
            );
        } else {
            this.province.closest('.form-field__container').classList.add('hidden');
            this.province.setAttribute('disabled', 'disabled');
            this.province.removeAttribute('required');

            this.dispatchEvent(
                new CustomEvent('form-validation:remove-input', {
                    bubbles: true,
                    detail: {
                        input: this.province,
                    },
                }),
            );
        }
    }
}

customElements.define('country-province-field', CountryProvinceField);

class DOBField extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input');
        this.input.addEventListener('keydown', this.forceNumeric.bind(this));
        this.input.addEventListener('keyup', this.forceFormatting.bind(this));
    }

    forceNumeric(event) {
        let dateValue = this.input.value;
        if (
            (isNaN(event.key) || dateValue.length >= 10) &&
            !['Enter', 'Backspace', 'Delete', 'Shift', 'Tab', 'ArrowLeft', 'ArrowRight'].includes(event.key)
        ) {
            event.preventDefault();
        }
    }

    forceFormatting(event) {
        let dateValue = this.input.value;
        if (dateValue.length === 3 && dateValue.charAt(2) !== '/')
            this.input.value = dateValue.slice(0, 2) + '/' + dateValue.slice(2);
        if (dateValue.length === 6 && dateValue.charAt(5) !== '/')
            this.input.value = dateValue.slice(0, 5) + '/' + dateValue.slice(5);
    }
}

customElements.define('dob-field', DOBField);

class PasswordField extends HTMLElement {
    constructor() {
        super();
        this.button = this.querySelector('button');
        this.input = this.querySelector('input');
        this.hiddenIcon = this.querySelector('.password-field__hidden');
        this.visibleIcon = this.querySelector('.password-field__visible');
        this.button.addEventListener('click', this.toggleVisibility.bind(this));
    }

    toggleIcon() {
        if (!this.hiddenIcon || !this.visibleIcon) return;
        this.hiddenIcon.classList.toggle('hidden');
        this.visibleIcon.classList.toggle('hidden');
    }

    toggleVisibility(event) {
        event.preventDefault();
        this.input.setAttribute('type', this.input.getAttribute('type') === 'password' ? 'text' : 'password');
        this.toggleIcon();
    }
}

customElements.define('password-field', PasswordField);

class SubscriptionInfo extends HTMLElement {
    constructor() {
        super();
        this.button = this.querySelector('button');
        this.button.addEventListener('click', this.toggleSubscriptionModal.bind(this));
    }

    toggleSubscriptionModal(event) {
        event.preventDefault();
        const tiers = this.button.dataset.subscriptionItems ? this.button.dataset.subscriptionItems.split(', ') : null;
        document.dispatchEvent(
            new CustomEvent('modal:open', {
                detail: {
                    modal: '.understanding-subs-modal',
                    tiers: tiers,
                },
            }),
        );
    }
}

customElements.define('subscription-info', SubscriptionInfo);

class SubscriptionModule extends HTMLElement {
    constructor() {
        super();
        this.select = this.querySelector('select[name="properties[_subscription]"]');
        this.checkbox = this.querySelector('input[name="subscription-toggle"]');
        this.settingsTemplate = this.querySelector('script[type="text/template"]');
        this.settings = this.settingsTemplate ? JSON.parse(this.settingsTemplate.innerHTML) : undefined;

        if (this.checkbox) this.checkbox.addEventListener('change', this.subscriptionChange.bind(this));
    }

    subscriptionChange(event) {
        const newValue = this.checkbox.checked ? 'true' : 'false';
        this.select.value = newValue;
        if (newValue === 'true')
            sendAnalyticsEventData(USER_INTERACTION_ANALYTICS_EVENTS.subscribeToggle, {
                ...this.settings,
            });
    }
}

customElements.define('subscription-module', SubscriptionModule);

// Live Chat Widget Code.

if (window.platformScripts.isLiveChat) {
    const contactUs = {
        liveChatButton: '#chat_button',
        liveChatWidget: '.embeddedServiceHelpButton button.helpButtonEnabled',
        init: function () {
            this.checkLiveChatStatus();
        },
        checkIcon: function (callback) {
            let loopCount = 0;
            const chatCheck = setInterval(() => {
                if (!document.querySelector(this.liveChatWidget) && loopCount <= 5) {
                    loopCount++;
                } else {
                    clearInterval(chatCheck);
                    callback(loopCount > 5 ? false : true);
                }
            }, 1000);
        },
        checkLiveChatStatus: function () {
            const button = document.querySelector(this.liveChatButton);
            if (button) {
                this.checkIcon((response) => {
                    if (response) {
                        button.textContent = window.accessibilityStrings.chat.onlineStatus;
                        button.removeAttribute('disabled');

                        button.addEventListener('click', (event) => {
                            event.preventDefault();
                            const widget = document.querySelector(this.liveChatWidget);
                            if (widget) {
                                widget.click();
                            }
                        });
                    } else {
                        button.textContent = window.accessibilityStrings.chat.offlineStatus;
                    }
                });
            }
        },
    };

    document.addEventListener('DOMContentLoaded', function () {
        contactUs.init();
    });
}

class LoginForm extends FormValidation {
    constructor() {
        super();

        this.form = this.querySelector('form');
        this.error = this.querySelector('.global-message');
        this.errorContent = this.querySelector('.global-message__copy');
        this.loadingSpinner = this.querySelector('.generic-form__spinner');

        this.form.addEventListener('submit', this.formSubmit.bind(this));
    }

    connectedCallback() {
        this.checkLoggedOut();
    }

    formSubmit() {
        if (!this.hasValidated) return;
        this.handleLoginValidation();
    }

    showLoadingState() {
        if (!this.loadingSpinner) return;
        this.loadingSpinner.classList.remove('hidden');
    }

    hideLoadingState() {
        if (!this.loadingSpinner) return;
        this.loadingSpinner.classList.add('hidden');
    }

    generateErrorMessage() {
        const locales = window.loginSidebarStrings.loginErrorMsg;
        const errorMessage = document.createElement('SPAN');
        const errorLink = document.createElement('A');
        errorLink.href = getGlobalDomain(locales.partLink);
        errorLink.textContent = locales.partTwo;
        errorMessage.append(`${locales.partOne} `, errorLink, ` ${locales.partThree}`);
        return errorMessage;
    }

    handleCreateAccountLink() {
        const registerLink = this.errorContent.querySelector('.js-register-link');
        if (!registerLink) return;
        const registerToggle = document.querySelector('.login-sidebar__tabs .tabs__item[name="no-account"]');
        if (!registerToggle) return;
        registerLink.addEventListener('click', (event) => {
            event.preventDefault();
            registerToggle.click();
        });
    }

    displayLoginError(networkError = false, accountExists = true) {
        this.errorContent.innerHTML = '';
        if (networkError) {
            this.errorContent.innerHTML = window.loginSidebarStrings.networkErrorMsg;
        } else if (!accountExists) {
            this.errorContent.innerHTML = window.loginSidebarStrings.loginErrorMsg.noAccountErrorMsg;
            this.handleCreateAccountLink();
        } else {
            this.errorContent.append(this.generateErrorMessage());
        }
        this.error.classList.add('global-message--active');
    }

    handleLoginCheck() {
        this.error.classList.remove('global-message--active');
        fetch(getGlobalDomain('/apps/bat-social/authenticate'), {
            method: 'POST',
            body: new URLSearchParams(new FormData(this.form)),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.ok) {
                    if (data?.token) {
                        fetch(getGlobalDomain('/account/login/multipass/') + data.token)
                            .then((response) => response.json())
                            .finally(() => {
                                sendAnalyticsEventData(USER_INTERACTION_ANALYTICS_EVENTS.login);
                                fetch(getGlobalDomain('/cart/update')).finally(() => {
                                    const returnToParam = new URLSearchParams(window.location.search).get('return_to');

                                    if (returnToParam) {
                                        window.location.href = returnToParam;
                                    } else {
                                        const previousLogInUrl = window.location.href;
                                        const loginToCheckout = window.location.hash == '#loginToCheckout';
                                        if (
                                            previousLogInUrl.includes('checkout_url') ||
                                            previousLogInUrl.includes('loginToCheckout') ||
                                            loginToCheckout
                                        ) {
                                            window.velocityCartManager.goToCheckout();
                                        } else {
                                            window.location.href = previousLogInUrl + '?logged-in=true';
                                        }
                                    }
                                });
                            });
                        // window.location.href = getGlobalDomain("/account/login/multipass/") + data.token;
                    } else {
                        sendAnalyticsEventData(USER_INTERACTION_ANALYTICS_EVENTS.login, {
                            failed: {
                                reason: 'incorrect_credentials',
                                fields: 'password',
                            },
                        });
                        this.hideLoadingState();
                        this.displayLoginError();
                    }
                } else {
                    this.hideLoadingState();
                    this.displayLoginError(false, data.accountExists);
                    sendAnalyticsEventData(USER_INTERACTION_ANALYTICS_EVENTS.login, {
                        failed: {
                            reason: 'incorrect_credentials',
                            fields: 'password',
                        },
                    });
                }
            })
            .catch((error) => {
                console.error(error);
                this.displayLoginError(true);
                this.hideLoadingState();
            });

        if (document.body.getAttribute('data-customer-invitation')) {
            document.removeEventListener('login:checked', this.handleLoginCheck, false);
        }
    }

    handleLoginValidation() {
        this.showLoadingState();

        if (document.body.getAttribute('data-customer-invitation')) {
            document.dispatchEvent(
                new CustomEvent('login:check', {
                    detail: {
                        form: this.form,
                    },
                }),
            );

            document.addEventListener('login:checked', this.handleLoginCheck());
        } else {
            this.handleLoginCheck();
        }
    }
    checkLoggedOut() {
        const url = new URL(window.location.href);
        if (url.searchParams.get('logged-out')) {
            sendAnalyticsEventData(USER_INTERACTION_ANALYTICS_EVENTS.logout);
            history.replaceState(history.state, '', window.location.origin);
        }
    }
}

customElements.define('login-form', LoginForm);

class AddAddress extends FormValidation {
    constructor() {
        super();

        this.form = this.querySelector('form');

        this.updateReturnToUrl();

        this.form.addEventListener('submit', this.formSubmit.bind(this));
    }

    updateReturnToUrl() {
        if (window.location.href.includes('/pages/checkout')) {
            const returnToInput = this.form.querySelector('input[name="return_to"]');
            if (returnToInput) {
                returnToInput.value = getGlobalDomain('/pages/checkout');
            }
        }
    }

    async submit(body) {
        try {
            // Create regular object for JSON
            const formattedData = {};

            // Map form fields
            const fieldMapping = {
                'address[first_name]': 'firstName',
                'address[last_name]': 'lastName',
                'address[phone]': 'phone',
                'address[company]': 'company',
                'address[address1]': 'line1',
                'address[address2]': 'line2',
                'address[city]': 'city',
                'address[province]': 'province',
                'address[country]': 'country',
                'address[zip]': 'zip',
            };

            for (let [formField, apiField] of Object.entries(fieldMapping)) {
                const value = body.get(formField);
                if (value) {
                    formattedData[apiField] = value;
                }
            }

            const addressFormRequest = await fetch(getGlobalDomain('/apps/bat-enhanced/address'), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formattedData),
            });

            const addressFormResponse = await addressFormRequest.json();

            if (!addressFormResponse.ok) {
                this.querySelector('.global-message').classList.add('global-message--active', 'global-message--error');
                this.querySelector('.global-message .global-message__title').innerHTML = addressFormResponse.message;
                console.error(addressFormResponse.message);
                return;
            }

            window.location = this.querySelector('input[name="return_to"]').value;
        } catch (e) {
            console.error(e);
            this.querySelector('.global-message').classList.add('global-message--active', 'global-message--error');
            this.querySelector('.global-message .global-message__title').innerHTML = e.message;
        }
    }

    formSubmit(event) {
        event.preventDefault();
        const formData = new FormData(this.form);
        const phone = formData.get('address[phone]');

        if (phone != '' && !phone.startsWith(window.validation[Shopify.country].phone.prefix))
            formData.set('address[phone]', `${window.validation[Shopify.country].phone.prefix}${phone}`);

        if (!this.hasValidated) return;
        this.submit(formData);
    }
}

customElements.define('add-address', AddAddress);

class EditAddress extends FormValidation {
    constructor() {
        super();

        this.form = this.querySelector('form');

        this.updateReturnToUrl();

        this.form.addEventListener('submit', this.formSubmit.bind(this));
    }

    updateReturnToUrl() {
        if (window.location.href.includes('/pages/checkout')) {
            const returnToInput = this.form.querySelector('input[name="return_to"]');
            if (returnToInput) {
                returnToInput.value = getGlobalDomain('/pages/checkout');
            }
        }
    }

    async submit(body) {
        try {
            // Create regular object for JSON
            const formattedData = {};

            if (this.id.includes('EditAddress_')) {
                formattedData['id'] = this.id.split('EditAddress_')[1];
            }

            // Map form fields
            const fieldMapping = {
                'address[first_name]': 'firstName',
                'address[last_name]': 'lastName',
                'address[phone]': 'phone',
                'address[company]': 'company',
                'address[address1]': 'line1',
                'address[address2]': 'line2',
                'address[city]': 'city',
                'address[province]': 'province',
                'address[country]': 'country',
                'address[zip]': 'zip',
            };

            for (let [formField, apiField] of Object.entries(fieldMapping)) {
                const value = body.get(formField);
                if (value) {
                    formattedData[apiField] = value;
                }
            }

            const addressFormRequest = await fetch(getGlobalDomain('/apps/bat-enhanced/address'), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formattedData),
            });

            const addressFormResponse = await addressFormRequest.json();

            if (!addressFormResponse.ok) {
                this.querySelector('.global-message').classList.add('global-message--active', 'global-message--error');
                this.querySelector('.global-message .global-message__title').innerHTML = addressFormResponse.message;
                console.error(addressFormResponse.message);
                return;
            }

            window.location = this.querySelector('input[name="return_to"]').value;
        } catch (e) {
            console.error(e);
            this.querySelector('.global-message').classList.add('global-message--active', 'global-message--error');
            this.querySelector('.global-message .global-message__title').innerHTML = e.message;
        }
    }

    formSubmit(event) {
        event.preventDefault();
        const formData = new FormData(this.form);
        const phone = formData.get('address[phone]');

        if (phone != '' && !phone.startsWith(window.validation[Shopify.country].phone.prefix))
            formData.set('address[phone]', `${window.validation[Shopify.country].phone.prefix}${phone}`);

        if (!this.hasValidated) return;
        this.submit(formData);
    }
}

customElements.define('edit-address', EditAddress);

class QuickAddressFinder extends HTMLElement {
    constructor() {
        super();
        this.form = this.closest('add-address');
        this.quickAddressFinder = this.querySelector('input[name="quickAddressFinder"]');
        this.quickAddressFinderContainer = this.querySelector('.toggle-address__manually');
        this.addressFields = this.querySelector('.address-fields');

        this.fields = [
            {
                element: this.quickAddressFinder,
                field: '',
            },
            {
                element: this.querySelector('input[name="address[company]"]'),
                field: 'Company',
                mode: pca.fieldMode.POPULATE,
            },
            {
                element: this.querySelector('input[name="address[company]"]'),
                field: 'BuildingNumber',
                mode: pca.fieldMode.POPULATE,
            },
            {
                element: this.querySelector('input[name="address[address1]"]'),
                field: 'Line1',
                mode: pca.fieldMode.POPULATE,
            },
            {
                element: this.querySelector('input[name="address[address2]"]'),
                field: 'Line2',
                mode: pca.fieldMode.POPULATE,
            },
            {
                element: this.querySelector('input[name="address[city]"]'),
                field: 'City',
                mode: pca.fieldMode.POPULATE,
            },
            {
                element: this.querySelector('input[name="address[province]"]'),
                field: 'Province',
                mode: pca.fieldMode.POPULATE,
            },
            {
                element: this.querySelector('input[name="address[zip]"]'),
                field: 'PostalCode',
                mode: pca.fieldMode.POPULATE,
            },
        ];

        this.options = {
            key: window.platformScripts.api.loqate,
            search: { countries: Shopify.country },
            setCountryByIP: true,
        };

        this.control = new pca.Address(this.fields, this.options);
        this.control.listen('populate', this.populateAddresses.bind(this));
    }

    populateAddresses() {
        this.addressFields.classList.remove('hidden');
        this.quickAddressFinderContainer.classList.add('hidden');
        this.form.removeValidationAndListeners(this.quickAddressFinder);

        this.fields.forEach((field) => {
            if (!field.element) return;
            field.element.dispatchEvent(new Event('input'));
        });
    }
}

customElements.define('quick-address-finder', QuickAddressFinder);

function formatMoney(cents, format) {
    if (typeof cents == 'string') {
        cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || this.money_format;

    function defaultOption(opt, def) {
        return typeof opt == 'undefined' ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) {
            return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents = parts[1] ? decimal + parts[1] : '';

        return dollars + cents;
    }

    var match = formatString.match(placeholderRegex);

    if (match) {
        switch (match[1]) {
            case 'amount':
                value = formatWithDelimiters(cents, 2);
                break;
            case 'amount_no_decimals':
                value = formatWithDelimiters(cents, 0);
                break;
            case 'amount_with_comma_separator':
                value = formatWithDelimiters(cents, 2, '.', ',');
                break;
            case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters(cents, 0, '.', ',');
                break;
        }
    }

    return formatString.replace(placeholderRegex, value);
}

class ToggleTabs extends HTMLElement {
    constructor() {
        super();
        this.toggles = this.querySelectorAll('.tabs__item');
        this.tabs = this.querySelectorAll('.tabs-content__item');
        this.toggles.forEach((toggle) => {
            toggle.addEventListener('click', this.toggleItem.bind(this));
        });

        this.initializeInertState();
    }

    toggleItem(event) {
        this.toggle = event.target;
        this.toggles.forEach((toggle) => {
            if (toggle === this.toggle) {
                toggle.classList.add('tabs__item--active');
            } else {
                toggle.classList.remove('tabs__item--active');
            }
            this.toggleContent();
        });
    }

    initializeInertState() {
        // Find the active toggle and set inert state accordingly
        const activeToggle = this.querySelector('.tabs__item--active');
        if (activeToggle) {
            const activeToggleName = activeToggle.getAttribute('name');
            this.tabs.forEach((tab) => {
                const tabAttr = tab.getAttribute('data-attr');
                if (!tabAttr) return;

                if (tabAttr === activeToggleName) {
                    tab.removeAttribute('inert');
                } else {
                    tab.setAttribute('inert', '');
                }
            });
        }
    }

    toggleContent() {
        this.toggleName = this.toggle.getAttribute('name');
        if (!this.toggleName) return;

        this.tabs.forEach((tab) => {
            this.tabAttr = tab.getAttribute('data-attr');
            if (!this.tabAttr) return;

            if (this.tabAttr === this.toggleName) {
                tab.classList.add('tabs-content__item--active');
                tab.removeAttribute('inert');
            } else {
                tab.classList.remove('tabs-content__item--active');
                tab.setAttribute('inert', '');
            }
        });
    }
}

customElements.define('toggle-tabs', ToggleTabs);

class CountdownTimer extends HTMLElement {
    constructor() {
        super();
        this.endDateSetting = this.getAttribute('data-counter-end-date');
        this.endTimeSetting = this.getAttribute('data-counter-end');
        this.daysEl = this.querySelector('.time-loading--days');
        this.hoursEl = this.querySelector('.time-loading--hours');
        this.minutesEl = this.querySelector('.time-loading--minutes');
        this.secondsEl = this.querySelector('.time-loading--seconds');

        if (!this.endTimeSetting && !this.endDateSetting) return;

        setInterval(this.updateContent.bind(this), 1000);
    }

    updateContent() {
        if (this.endTimeSetting) {
            [this.endHour, this.endMinute] = this.endTimeSetting.split(':').map(Number);

            const now = new Date();
            let endOfDay = new Date();
            endOfDay.setHours(this.endHour, this.endMinute, 0);

            if (now > endOfDay) {
                endOfDay.setDate(now.getDate() + 1);
            }
            const diff = endOfDay - now;
            const hours = Math.floor(diff / 1000 / 60 / 60);
            const mins = Math.floor(diff / 1000 / 60) % 60;
            const secs = Math.floor(diff / 1000) % 60;
            [this.endHours, this.endMinutes, this.endSeconds] = [hours, mins, secs];
        }

        if (this.endDateSetting) {
            const [day, month, year] = this.endDateSetting.split('-');
            const endDate = new Date(`${year}-${month}-${day}`); // converts to 2026-06-25
            const diff = endDate - new Date();
            if (diff <= 0) return;

            const days = Math.floor(diff / 86400000);
            const hours = Math.floor((diff % 86400000) / 3600000);
            const mins = Math.floor((diff % 3600000) / 60000);
            const secs = Math.floor((diff % 60000) / 1000);
            [this.endDays, this.endHours, this.endMinutes, this.endSeconds] = [days, hours, mins, secs];
        }

        if (this.endDays) {
            this.daysEl.textContent = String(this.endDays).padStart(2, '0');
        }

        this.hoursEl.textContent = String(this.endHours).padStart(2, '0');
        this.minutesEl.textContent = String(this.endMinutes).padStart(2, '0');
        this.secondsEl.textContent = String(this.endSeconds).padStart(2, '0');

        [this.daysEl, this.hoursEl, this.minutesEl, this.secondsEl].forEach((el) => {
            if (el.classList.contains('time-loading')) {
                el.classList.remove('time-loading');
            }
        });
    }
}
customElements.define('countdown-timer', CountdownTimer);

class NewsletterComponent extends HTMLElement {
    constructor() {
        super();
        this.isOpen = false;
        this.isCustomer = window.customerVariables.isCustomer;
        this.newsletter_triggers = this.querySelectorAll('.button--newsletter');
        this.newsletter_triggers.forEach((newsletter_trigger) => {
            newsletter_trigger.addEventListener('click', this.toggleModal.bind(this));
        });

        const floatingNewsletterPopupDismissed = sessionStorage.getItem('closeFloatingNewsletterPopup');
        if (floatingNewsletterPopupDismissed == null) {
            this.newsletter_floating_popup = this.querySelector('.newsletter__floating-popup');
            if (this.newsletter_floating_popup && newsletter_floating_popup_delay) {
                this.showFloatingPopup(newsletter_floating_popup_delay);
            }
            this.newsletter_floating_close = this.querySelector('.newsletter__floating-popup-close');
            if (this.newsletter_floating_close)
                this.newsletter_floating_close.addEventListener('click', this.closeFloatingPopup.bind(this));
        }
    }

    showFloatingPopup(delay) {
        setTimeout(
            () => {
                this.newsletter_floating_popup.classList.remove('hidden');
            },
            parseInt(delay + '000'),
        );
    }

    closeFloatingPopup() {
        this.newsletter_floating_popup.remove();
        sessionStorage.setItem('closeFloatingNewsletterPopup', 'true');
    }

    toggleModal(event) {
        event.preventDefault();
        if (this.isCustomer) {
            document.dispatchEvent(
                new CustomEvent('account:open', {
                    detail: {
                        tab: 'marketing-preferences',
                    },
                }),
            );
        } else {
            this.newsletter_popup = document.querySelectorAll('#newsletter-popup, .newsletter-overlay');
            this.newsletter_popup.forEach((newsletter_popup) => {
                if (newsletter_popup.getAttribute('class').includes('active')) {
                    newsletter_popup.classList.remove('active');
                } else {
                    newsletter_popup.classList.add('active');
                }
            });
            document.body.classList.toggle('overflow-hidden');
        }
    }
}

customElements.define('newsletter-component', NewsletterComponent);

class ProductInfoDescription extends HTMLElement {
    constructor() {
        super();

        if (this.querySelector('.product-line-description-wrapper__header')) {
            this.querySelector('.product-line-description-wrapper__header').addEventListener(
                'click',
                this.openToggle.bind(this),
            );
        }
    }

    openToggle(event) {
        this.querySelector('.product-line-description-wrapper__content').classList.toggle(
            'product-line-description-wrapper__content--active',
        );
        this.querySelector('.product-line-description-wrapper__header-icons').classList.toggle(
            'product-line-description-wrapper__header-icons--active',
        );
    }
}

customElements.define('product-info-component', ProductInfoDescription);

// This is a necessary evil to do the mobile menu height including all announcement bars that have been added
document.addEventListener('DOMContentLoaded', () => {
    const headerGroupHeight = Array.from(document.querySelectorAll('.shopify-section-group-header-group'))
        .map((el) => el.clientHeight)
        .reduce((a, b) => a + b, 0);

    const headerStickyGroupHeight = Array.from(document.querySelectorAll('.shopify-section-header-sticky'))
        .map((el) => el.clientHeight)
        .reduce((a, b) => a + b, 0);

    const verifyBottomBar = document.querySelector('.fixed-verify-bar')
        ? document.querySelector('.fixed-verify-bar').clientHeight
        : 0;

    document.body.style.setProperty('--header-height', `${headerGroupHeight}px`);
    document.body.style.setProperty('--header-sticky-height', `${headerStickyGroupHeight}px`);
    document.body.style.setProperty('--verify-bar', `${verifyBottomBar}px`);
});

class LocalizationForm extends HTMLElement {
    constructor() {
        super();
        this.toggleButtons = this.querySelectorAll('[name="localization"]');

        this.toggleButtons.forEach((button) =>
            button.addEventListener('click', this.handleLocalizationChange.bind(this)),
        );
    }

    handleLocalizationChange(event) {
        event.preventDefault;
        const locale = event.target.value;
        if (!locale) return;
        const currentLocale = window.Shopify.routes.root.replaceAll('/', '');
        if (!currentLocale.includes('-')) return;
        const localeParts = currentLocale.split('-');
        const newLocale = locale + '-' + localeParts[1];
        window.location.href = window.location.href.replace(currentLocale, newLocale);
    }
}

customElements.define('localization-form', LocalizationForm);

class TextWithAnimatedBlocks extends HTMLElement {
    constructor() {
        super();
        this.currentActiveBlock = 0;
        this.blocks = this.querySelectorAll('.text-with-animated-blocks__block');

        if (this.blocks.length > 0) {
            this.setAnimationTimer();
        }
    }

    setAnimationTimer() {
        setInterval(() => {
            if (this.currentActiveBlock >= this.blocks.length) {
                this.currentActiveBlock = 0;
            }
            this.querySelector('.text-with-animated-blocks__block--active').classList.remove(
                'text-with-animated-blocks__block--active',
            );
            this.blocks[this.currentActiveBlock].classList.add('text-with-animated-blocks__block--active');
            this.currentActiveBlock++;
        }, 2000);
    }
}

customElements.define('text-with-animated-blocks', TextWithAnimatedBlocks);

class HeadingWithIconRowAnimated extends HTMLElement {
    constructor() {
        super();

        this.blocks = this.querySelectorAll('.js-heading-with-icon-row-animated-block');
        this.mobileIcons = this.querySelectorAll('.js-heading-with-icon-row-animated-mobile-icon');
        this.mobileIcons.forEach((mobileIcon) => {
            mobileIcon.addEventListener('click', this.toggleMobileIcon.bind(this));
        });
    }

    toggleMobileIcon(event) {
        event.preventDefault();
        const button = event.target;
        const blockIndex = parseInt(button.dataset.blockIndex) - 1;

        this.blocks.forEach((block) => {
            block.classList.remove('heading-with-icon-row-animated__block--active');
        });
        this.blocks[blockIndex].classList.add('heading-with-icon-row-animated__block--active');

        this.mobileIcons.forEach((mobileIcon) => {
            mobileIcon.classList.remove('heading-with-icon-row-animated__mobile-icon--active');
        });
        button.classList.add('heading-with-icon-row-animated__mobile-icon--active');
    }
}

customElements.define('heading-with-icon-row-animated', HeadingWithIconRowAnimated);

class EventCarousel extends HTMLElement {
    constructor() {
        super();
        this.tinySliderEl = this.querySelector('tiny-slider');
        this.filterButtons = this.querySelectorAll('.js-event-carousel-filter');
        this.filterDropdown = this.querySelector('.js-event-carousel-select-filter');

        // Store original slides before TinySlider mutates the DOM
        this.allSlides = Array.from(this.querySelectorAll('.js-event-carousel-slide')).map((slide) =>
            slide.cloneNode(true),
        );

        this.filterButtons.forEach((filterButton) => {
            filterButton.addEventListener('click', this.filterEvents.bind(this, 'tabs'));
        });

        this.filterDropdown?.addEventListener('change', this.filterEvents.bind(this, 'dropdown'));
    }

    rebuildSlider(slides) {
        const tinySliderEl = this.tinySliderEl;

        // Destroy the existing tns instance on the custom element
        if (tinySliderEl.slider) {
            tinySliderEl.slider.destroy();
            tinySliderEl.slider = null;
        }

        const slidesEl = tinySliderEl.querySelector('.js-event-carousel-slides');
        slidesEl.innerHTML = '';
        slides.forEach((slide) => {
            slidesEl.appendChild(slide.cloneNode(true));
        });

        // Regenerate config and reinitialise tns using the same config the element uses
        const config = new TinySliderConfig().generateConfig(tinySliderEl);
        tinySliderEl.slider = tns(config);

        // Re-run onInit to restore events, keyboard controls, aria etc.
        tinySliderEl.onInit();
    }

    filterEvents(type, e) {
        e.preventDefault();
        let filtered = [];

        //  Check for tab filter selection/click event or switch to selection for dropdown //
        if (type == 'tabs') {
            const button = e.currentTarget;
            const isActive = button.classList.contains('button--primary');
            const filter = button.dataset.filter;

            this.filterButtons.forEach((filterButton) => {
                filterButton.classList.remove('button--primary');
                filterButton.classList.add('button--secondary');
            });

            if (!isActive) {
                button.classList.remove('button--secondary');
                button.classList.add('button--primary');
            }

            filtered = isActive
                ? this.allSlides
                : this.allSlides.filter((slide) => {
                      const values = (slide.dataset.filterValues || '').split(',').map((v) => v.trim());
                      return values.includes(filter);
                  });
        } else {
            const selection = e.currentTarget;
            const filter = selection.filter;

            filtered =
                selection.value === 'all'
                    ? this.allSlides
                    : this.allSlides.filter((slide) => {
                          const values = (slide.dataset.filterValues || '').split(',').map((v) => v.trim());
                          return values.includes(selection.value);
                      });
        }

        if (filtered.length > 0) {
            this.rebuildSlider(filtered);
        } else {
            this.tinySliderEl.innerHTML = '<p class="no-results">No results found.</p>';
            if (this.tinySliderEl.slider) {
                this.tinySliderEl.slider.destroy();
                this.tinySliderEl.slider = null;
            }
        }
    }
}

customElements.define('event-carousel', EventCarousel);

class EventCountdown extends HTMLElement {
    constructor() {
        super();
        this.interval = null;
        this.removeTimer = this.getAttribute('remove-timer');
        this.days = this.querySelector('#days');
        this.hours = this.querySelector('#hours');
        this.minutes = this.querySelector('#minutes');
        this.seconds = this.querySelector('#seconds');
        this.targetTime = Date.now();
    }

    connectedCallback() {
        this.startTimer();
    }

    disconnectedCallback() {
        if (this.interval !== null) {
            clearInterval(this.interval);
        }
    }

    attributeChangedCallback() {
        this.startTimer();
    }

    startTimer() {
        if (this.interval !== null) {
            clearInterval(this.interval);
        }

        const targetDate = this.getAttribute('target-date');
        if (!targetDate) return;

        this.targetTime = new Date(targetDate).getTime();
        this.updateDisplay();

        this.interval = setInterval(() => {
            this.updateDisplay();
        }, 1000);
    }

    updateDisplay() {
        const now = Date.now();
        const timeLeft = this.targetTime - now;

        if (timeLeft <= 0) {
            if (this.removeTimer == 'true') {
                this.remove();
            }
            clearInterval(this.interval);
            return;
        }

        const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
        const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

        if (this.days && this.hours && this.minutes && this.seconds) {
            this.days.textContent = String(days).padStart(2, '0');
            this.hours.textContent = String(hours).padStart(2, '0');
            this.minutes.textContent = String(minutes).padStart(2, '0');
            this.seconds.textContent = String(seconds).padStart(2, '0');
        }
    }
}

customElements.define('event-countdown', EventCountdown);

// Events hub section toggles and load more states //
class EventsHub extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.paginate_by = this.dataset.eventPaginate;
        this.tabButtons = this.querySelectorAll('.events-hub__tab-button');
        this.tabContents = this.querySelectorAll('.events-hub__tab-content');
        this.monthly_filter = this.querySelector('.js-event-hub-monthly');

        // Initial DOM cleanup on load
        this.tabContents.forEach((tab) => this.resetTabState(tab));

        // Handle Tabs //
        this.tabButtons.forEach((btn) => {
            btn.addEventListener('click', (e) => this.switchTab(e));
        });

        // Handle Pagination //
        this.querySelectorAll('.events-hub__paginate-button').forEach((btn) => {
            btn.addEventListener('click', (e) => this.loadMore(e));
        });

        // Handle month filter //
        this.monthly_filter?.addEventListener('change', this.monthlyFilter.bind(this));
    }

    switchTab(e) {
        e.preventDefault();
        const clickedBtn = e.currentTarget;
        const targetValue = clickedBtn.getAttribute('data-target');

        this.tabButtons.forEach((btn) => {
            btn.classList.remove('events-hub__tab-button--active');
        });
        clickedBtn.classList.add('events-hub__tab-button--active');

        if (clickedBtn.dataset.target === 'past') {
            this.querySelector('.events-hub__filter-dropdown-wrapper').classList.add(
                'events-hub__filter-dropdown-wrapper--hidden',
            );
        } else {
            this.querySelector('.events-hub__filter-dropdown-wrapper').classList.remove(
                'events-hub__filter-dropdown-wrapper--hidden',
            );
        }

        this.tabContents.forEach((tab) => {
            const timeline = tab.getAttribute('data-timeline') || tab.id;

            if (timeline && timeline.trim() === targetValue.trim()) {
                tab.classList.add('events-hub__tab-content--active');
                tab.style.display = 'block';
                this.resetTabState(tab);
            } else {
                tab.classList.remove('events-hub__tab-content--active');
                tab.style.display = 'none';
            }
        });
    }

    // Call this whenever a user switches tabs to reset the dropdown and view
    resetTabState(currentTab) {
        if (this.monthly_filter) this.monthly_filter.value = 'all';
        this.updateVisibility(currentTab, 'all', Number(this.paginate_by));
    }

    monthlyFilter(e) {
        const filter = e.currentTarget;
        const selectedMonth = filter.value;

        // Find whichever tab is currently active
        let currentTab = this.querySelector('.events-hub__tab-content--active');
        if (!currentTab) {
            currentTab =
                Array.from(this.tabContents).find((tab) => tab.style.display !== 'none') || this.tabContents[0];
        }

        this.updateVisibility(currentTab, selectedMonth, Number(this.paginate_by));
    }

    loadMore(e) {
        e.preventDefault();
        const btn = e.currentTarget;
        const currentTab = btn.closest('.events-hub__tab-content');
        const selectedMonth = this.monthly_filter ? this.monthly_filter.value : 'all';

        const isShowLessState = btn.getAttribute('data-state') === 'less';
        const chunk = Number(this.paginate_by);

        const filteredItems = Array.from(currentTab.querySelectorAll('.events-hub__event-item')).filter((item) => {
            return selectedMonth === 'all' || item.getAttribute('data-month') === selectedMonth;
        });

        const currentlyVisibleCount = filteredItems.filter(
            (item) => !item.classList.contains('events-hub__event-item--hidden'),
        ).length;

        let targetVisibleCount;

        if (isShowLessState) {
            // --- SHOW LESS (RESET) ---
            targetVisibleCount = chunk;

            this.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
        } else {
            targetVisibleCount = Math.min(filteredItems.length, currentlyVisibleCount + chunk);
        }

        this.updateVisibility(currentTab, selectedMonth, targetVisibleCount);
    }

    updateVisibility(currentTab, selectedMonth, targetVisibleCount) {
        if (!currentTab) return;

        const allItems = Array.from(currentTab.querySelectorAll('.events-hub__event-item'));
        const btn = currentTab.querySelector('.events-hub__paginate-button');
        const chunk = Number(this.paginate_by);
        const errorWarning = currentTab.querySelector('.events-hub__no-results');

        let matchCount = 0;

        allItems.forEach((item) => {
            const matchesFilter = selectedMonth === 'all' || item.getAttribute('data-month') === selectedMonth;

            if (matchesFilter) {
                if (matchCount < targetVisibleCount) {
                    item.classList.remove('events-hub__event-item--hidden');
                } else {
                    item.classList.add('events-hub__event-item--hidden');
                }
                matchCount++;
            } else {
                item.classList.add('events-hub__event-item--hidden');
            }
        });

        if (matchCount === 0) {
            let errorMessage = errorWarning.dataset.filterError;
            errorWarning.classList.remove('events-hub__no-results--hidden');
            errorWarning.innerHTML = errorMessage;
        } else {
            errorWarning.classList.add('events-hub__no-results--hidden');
        }

        if (!btn) return;

        const loadLessT = btn.dataset.loadLess;
        const loadMoreT = btn.dataset.loadMore;

        if (matchCount <= chunk) {
            btn.style.display = 'none';
        } else {
            btn.style.display = 'inline-block';

            if (targetVisibleCount >= matchCount) {
                btn.textContent = loadLessT;
                btn.setAttribute('data-state', 'less');
            } else {
                btn.textContent = loadMoreT;
                btn.removeAttribute('data-state');
            }
        }
    }
}

customElements.define('events-hub', EventsHub);

class VideoPrimary extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.mediaWrapper = this.querySelector('[data-media-wrapper]');
        if (!this.mediaWrapper) return;

        this.initResponsiveVideo();

        this.resizeObserver = new ResizeObserver(() => this.initResponsiveVideo());
        this.resizeObserver.observe(this);
    }

    disconnectedCallback() {
        this.resizeObserver?.disconnect();
    }

    initResponsiveVideo() {
        const isMobile = window.matchMedia('(max-width: 767px)').matches;

        const mobileVideo = this.querySelector('.video-primary__video--mobile');
        const desktopVideo = this.querySelector('.video-primary__video--desktop');
        const activeVideo = isMobile ? mobileVideo : desktopVideo;
        const inactiveVideo = isMobile ? desktopVideo : mobileVideo;

        console.log('activeVideo: ', activeVideo);

        if (activeVideo && !activeVideo.src) {
            const url = activeVideo.dataset.src;
            if (url) {
                activeVideo.src = url;
                activeVideo.load();
                if (activeVideo.dataset.autoplay === 'true') {
                    activeVideo.play().catch(() => {});
                }
            }
        }

        if (inactiveVideo?.src) {
            inactiveVideo.pause();
            inactiveVideo.src = '';
            inactiveVideo.removeAttribute('src');
            inactiveVideo.load();
        }

        const mobileIframe = this.querySelector(
            '.video-primary__embed--mobile, .video-primary__video-wrapper--mobile iframe',
        );
        const desktopIframe = this.querySelector(
            '.video-primary__embed--desktop, .video-primary__video-wrapper--desktop iframe',
        );
        const activeIframe = isMobile ? mobileIframe : desktopIframe;
        const inactiveIframe = isMobile ? desktopIframe : mobileIframe;

        if (activeIframe && !activeIframe.getAttribute('src')) {
            const url = activeIframe.dataset.src;
            if (url) activeIframe.setAttribute('src', url);
        }

        if (inactiveIframe?.getAttribute('src')) {
            inactiveIframe.removeAttribute('src');
        }
    }
}

if (!customElements.get('video-primary')) {
    customElements.define('video-primary', VideoPrimary);
}

class ReadMoreBanner extends HTMLElement {
    constructor() {
        super();
        this.boundHandleReadMoreToggle = this.handleReadMoreToggle.bind(this);
    }

    connectedCallback() {
        this.readMoreToggle = this.querySelector('.read-more-banner__read-more-toggle');
        this.readLessToggle = this.querySelector('.read-more-banner__read-less--toggle');

        this.readMoreContent = this.querySelector('.read-more-banner__read-more-content');

        this.readMoreToggle?.addEventListener('click', this.boundHandleReadMoreToggle);
        this.readLessToggle?.addEventListener('click', this.boundHandleReadMoreToggle);
    }

    disconnectedCallback() {
        this.readMoreToggle?.removeEventListener('click', this.boundHandleReadMoreToggle);
    }

    handleReadMoreToggle() {
        if (!this.readMoreToggle || !this.readLessToggle || !this.readMoreContent) return;

        const isExpanded = this.readMoreToggle.getAttribute('aria-expanded') === 'true';

        if (isExpanded) {
            this.collapseReadMoreContent();
            this.readMoreToggle.setAttribute('aria-expanded', 'false');
        } else {
            this.expandReadMoreContent();
            this.readMoreToggle.setAttribute('aria-expanded', 'true');
        }
    }

    expandReadMoreContent() {
        if (!this.readMoreContent) return;

        this.readMoreContent.setAttribute('aria-hidden', 'false');
        this.readMoreContent.removeAttribute('hidden');

        const currentMaxHeight = this.readMoreContent.style.maxHeight;
        this.readMoreContent.style.maxHeight = 'none';
        const height = this.readMoreContent.scrollHeight;
        this.readMoreContent.style.maxHeight = currentMaxHeight;

        void this.readMoreContent.offsetHeight;

        this.readMoreContent.style.maxHeight = `${height}px`;
        this.readMoreContent.classList.add('read-more-banner__read-more-content--expanded');

        this.readLessToggle?.classList.remove('is-hidden');
        this.readMoreToggle?.classList.add('is-hidden');
    }

    collapseReadMoreContent() {
        if (!this.readMoreContent) return;

        const height = this.readMoreContent.scrollHeight;
        this.readMoreContent.style.maxHeight = `${height}px`;

        void this.readMoreContent.offsetHeight;

        this.readMoreContent.classList.remove('read-more-banner__read-more-content--expanded');
        this.readMoreContent.style.maxHeight = '0';
        this.readMoreContent.style.marginTop = '-24px';

        this.readLessToggle?.classList.add('is-hidden');
        this.readMoreToggle?.classList.remove('is-hidden');

        setTimeout(() => {
            if (
                this.readMoreContent &&
                !this.readMoreContent.classList.contains('read-more-banner__read-more-content--expanded')
            ) {
                this.readMoreContent.setAttribute('aria-hidden', 'true');
                this.readMoreContent.setAttribute('hidden', '');
            }
        }, 200);
    }
}

customElements.define('read-more-banner', ReadMoreBanner);

class ContentCarouselWithAsset extends HTMLElement {
    constructor() {
        super();
        this.synced = false;
        this.syncRetries = 0;
        this.maxSyncRetries = 20;
        this.boundSyncAssetSlider = this.syncAssetSlider.bind(this);
    }

    connectedCallback() {
        this.initSyncedSliders();
    }

    disconnectedCallback() {
        if (this.contentSlider?.slider) {
            this.contentSlider.slider.events.off('indexChanged', this.boundSyncAssetSlider);
        }
    }

    initSyncedSliders() {
        this.contentSlider = this.querySelector('.content-carousel-with-asset__content-carousel tiny-slider');
        this.assetSlider = this.querySelector('.content-carousel-with-asset__gallery tiny-slider');

        if (!this.contentSlider || !this.assetSlider) return;

        if (!this.contentSlider.slider || !this.assetSlider.slider) {
            if (this.syncRetries >= this.maxSyncRetries) return;
            this.syncRetries += 1;
            requestAnimationFrame(() => this.initSyncedSliders());
            return;
        }

        if (this.synced) return;
        this.synced = true;

        this.contentSlider.slider.events.on('indexChanged', this.boundSyncAssetSlider);
    }

    syncAssetSlider(event) {
        if (!this.assetSlider?.slider) return;

        const assetIndex = this.assetSlider.slider.getInfo().index;
        if (assetIndex !== event.index) {
            this.assetSlider.slider.goTo(event.index);
        }
    }
}

customElements.define('content-carousel-with-asset', ContentCarouselWithAsset);

// Support for smooth scrolling on internal links with class //
document.querySelectorAll('a.smooth-scroll[href^="#"]').forEach((anchor) => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();

        const targetId = this.getAttribute('href');
        const targetElement = document.querySelector(targetId);

        if (targetElement) {
            targetElement.scrollIntoView({
                behavior: 'smooth',
            });
        }
    });
});
// On page click event for event hub and form same page //
document.querySelectorAll('.js-form-populate').forEach((button) => {
    button.addEventListener('click', (e) => {
        e.preventDefault();

        const currentButton = e.currentTarget;
        const formTarget = currentButton.dataset.formTarget;
        const radioTarget = currentButton.dataset.radioTarget;

        if (formTarget && radioTarget) {
            const el = document.querySelector(`#${formTarget} #${radioTarget}`);
            const value = el?.value;
            if (value) window.competitionFormApi?.setRadioOption(value);

            document.getElementById(formTarget).scrollIntoView({ behavior: 'smooth', block: 'start' });
            // Reset url //
            history.replaceState(null, null, window.location.pathname + window.location.search);
        }
    });
});
// Window load event to allow app load in before setting radio values //
window.addEventListener('load', () => {
    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams) {
        const formTarget = urlParams.get('form-target');
        const radioTarget = urlParams.get('radio-target');

        if (formTarget && radioTarget) {
            const el = document.querySelector(`#${formTarget} #${radioTarget}`);
            const value = el?.value;
            if (value) window.competitionFormApi?.setRadioOption(value);

            document.getElementById(formTarget).scrollIntoView({ behavior: 'smooth', block: 'start' });
        }

        // Clear params //
        urlParams.delete('radio-target');
        urlParams.delete('form-target');

        const remainingParams = urlParams.toString();
        const newUrl = remainingParams ? `${window.location.pathname}?${remainingParams}` : window.location.pathname;

        window.history.replaceState({}, document.title, newUrl);
    }
});
